(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4576],{

/***/ 84120:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/limit-orders",
      function () {
        return __webpack_require__(4057);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 22661:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87379);
/* harmony import */ var _Svg__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(17058);






var Icon = function Icon(props) {
    var theme = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .useTheme */ .Fg)();
    var primaryColor = theme.isDark ? "#3C3742" : "#e9eaeb";
    var secondaryColor = theme.isDark ? "#666171" : "#bdc2c4";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Svg__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        viewBox: "0 0 72 72"
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("image", {
            width: "72",
            height: "72",
            href: "/logo.png"
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Icon);


/***/ }),

/***/ 158:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Td": function() { return /* binding */ Td; },
/* harmony export */   "Th": function() { return /* binding */ Th; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87379);
/* harmony import */ var styled_system__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(57247);



function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)([
        "\n  border-bottom: 1px solid ",
        ";\n  color: ",
        ";\n  padding: 16px;\n  vertical-align: middle;\n\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)([
        "\n  color: ",
        ";\n  font-size: 12px;\n  text-transform: uppercase;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
var Td = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].td.withConfig */ .ZP.td.withConfig({
    componentId: "sc-ea0e7240-0"
}).withConfig({
    componentId: "sc-a0ae180c-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.cardBorder;
}, function(param) {
    var theme = param.theme;
    return theme.colors.text;
}, styled_system__WEBPACK_IMPORTED_MODULE_0__/* .typography */ .cp);
var Th = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(Td).attrs({
    as: "th"
}).withConfig({
    componentId: "sc-ea0e7240-1"
}).withConfig({
    componentId: "sc-a0ae180c-1"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.colors.secondary;
});


/***/ }),

/***/ 48993:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87379);
/* harmony import */ var styled_system__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(57247);
/* harmony import */ var _Cell__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(158);




function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)([
        "\n  max-width: 100%;\n  width: 100%;\n\n  tbody tr:last-child {\n    ",
        " {\n      border-bottom: 0;\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var Table = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].table.withConfig */ .ZP.table.withConfig({
    componentId: "sc-4fe367f7-0"
}).withConfig({
    componentId: "sc-b0f07fdc-0"
})(_templateObject(), _Cell__WEBPACK_IMPORTED_MODULE_3__.Td, styled_system__WEBPACK_IMPORTED_MODULE_0__/* .space */ .Dh);
/* harmony default export */ __webpack_exports__["Z"] = (Table);


/***/ }),

/***/ 118:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ components_SubgraphHealthIndicator; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/config/index.ts + 1 modules
var config = __webpack_require__(37519);
// EXTERNAL MODULE: ./packages/localization/src/index.tsx + 5 modules
var src = __webpack_require__(8253);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
// EXTERNAL MODULE: ./packages/uikit/src/components/Card/Card.tsx + 1 modules
var Card = __webpack_require__(38144);
// EXTERNAL MODULE: ./packages/uikit/src/components/Box/Flex.tsx
var Flex = __webpack_require__(4318);
// EXTERNAL MODULE: ./packages/uikit/src/components/Box/Box.tsx
var Box = __webpack_require__(44850);
// EXTERNAL MODULE: ./packages/uikit/src/hooks/useTooltip/useTooltip.tsx + 1 modules
var useTooltip = __webpack_require__(36544);
// EXTERNAL MODULE: ./packages/uikit/src/components/Text/Text.tsx
var Text = __webpack_require__(97114);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/Info.tsx
var Info = __webpack_require__(82035);
// EXTERNAL MODULE: ./src/state/user/hooks/index.tsx
var hooks = __webpack_require__(68605);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/graphql-request/dist/index.js
var dist = __webpack_require__(28687);
// EXTERNAL MODULE: ./src/utils/providers.ts + 1 modules
var providers = __webpack_require__(65684);
// EXTERNAL MODULE: ./src/config/constants/endpoints.ts
var endpoints = __webpack_require__(85906);
// EXTERNAL MODULE: ./src/hooks/useRefreshEffect.ts
var useRefreshEffect = __webpack_require__(27892);
;// CONCATENATED MODULE: ./src/hooks/useSubgraphHealth.ts




function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n            query getNftMarketSubgraphHealth {\n              indexingStatusForCurrentVersion(subgraphName: "',
        '") {\n                synced\n                health\n                chains {\n                  chainHeadBlock {\n                    number\n                  }\n                  latestBlock {\n                    number\n                  }\n                }\n              }\n            }\n          '
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var SubgraphStatus;
(function(SubgraphStatus) {
    SubgraphStatus[SubgraphStatus["OK"] = 0] = "OK";
    SubgraphStatus[SubgraphStatus["WARNING"] = 1] = "WARNING";
    SubgraphStatus[SubgraphStatus["NOT_OK"] = 2] = "NOT_OK";
    SubgraphStatus[SubgraphStatus["UNKNOWN"] = 3] = "UNKNOWN";
})(SubgraphStatus || (SubgraphStatus = {}));
var NOT_OK_BLOCK_DIFFERENCE = 200 // ~15 minutes delay
;
var WARNING_BLOCK_DIFFERENCE = 50 // ~2.5 minute delay
;
var useSubgraphHealth = function(subgraphName) {
    var ref = (0,react.useState)({
        status: SubgraphStatus.UNKNOWN,
        currentBlock: 0,
        chainHeadBlock: 0,
        latestBlock: 0,
        blockDifference: 0
    }), sgHealth = ref[0], setSgHealth = ref[1];
    (0,useRefreshEffect/* useSlowRefreshEffect */.X)(function(currentBlockNumber) {
        var getSubgraphHealth = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                var ref, indexingStatusForCurrentVersion, currentBlock, isHealthy, chainHeadBlock, latestBlock, blockDifference, chainHeadBlockDifference;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            _ctx.t0 = _sliced_to_array/* default */.Z;
                            _ctx.next = 4;
                            return Promise.all([
                                (0,dist.request)(endpoints/* GRAPH_HEALTH */.AM, (0,dist.gql)(_templateObject(), subgraphName)),
                                currentBlockNumber ? Promise.resolve(currentBlockNumber) : providers/* bscRpcProvider.getBlockNumber */.v.getBlockNumber(), 
                            ]);
                        case 4:
                            _ctx.t1 = _ctx.sent;
                            ref = (0, _ctx.t0)(_ctx.t1, 2);
                            indexingStatusForCurrentVersion = ref[0].indexingStatusForCurrentVersion;
                            currentBlock = ref[1];
                            isHealthy = indexingStatusForCurrentVersion.health === "healthy";
                            chainHeadBlock = parseInt(indexingStatusForCurrentVersion.chains[0].chainHeadBlock.number);
                            latestBlock = parseInt(indexingStatusForCurrentVersion.chains[0].latestBlock.number);
                            blockDifference = currentBlock - latestBlock;
                            chainHeadBlockDifference = currentBlock - chainHeadBlock;
                            if (!isHealthy || blockDifference > NOT_OK_BLOCK_DIFFERENCE || chainHeadBlockDifference > NOT_OK_BLOCK_DIFFERENCE) {
                                setSgHealth({
                                    status: SubgraphStatus.NOT_OK,
                                    currentBlock: currentBlock,
                                    chainHeadBlock: chainHeadBlock,
                                    latestBlock: latestBlock,
                                    blockDifference: blockDifference
                                });
                            } else if (blockDifference > WARNING_BLOCK_DIFFERENCE || chainHeadBlockDifference > WARNING_BLOCK_DIFFERENCE) {
                                setSgHealth({
                                    status: SubgraphStatus.WARNING,
                                    currentBlock: currentBlock,
                                    chainHeadBlock: chainHeadBlock,
                                    latestBlock: latestBlock,
                                    blockDifference: blockDifference
                                });
                            } else {
                                setSgHealth({
                                    status: SubgraphStatus.OK,
                                    currentBlock: currentBlock,
                                    chainHeadBlock: chainHeadBlock,
                                    latestBlock: latestBlock,
                                    blockDifference: blockDifference
                                });
                            }
                            _ctx.next = 19;
                            break;
                        case 16:
                            _ctx.prev = 16;
                            _ctx.t2 = _ctx["catch"](0);
                            console.error("Failed to perform health check for ".concat(subgraphName, " subgraph"), _ctx.t2);
                        case 19:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        16
                    ]
                ]);
            }));
            return function getSubgraphHealth() {
                return _ref.apply(this, arguments);
            };
        }();
        getSubgraphHealth();
    }, [
        subgraphName
    ]);
    return sgHealth;
};
/* harmony default export */ var hooks_useSubgraphHealth = (useSubgraphHealth);

;// CONCATENATED MODULE: ./src/components/SubgraphHealthIndicator/index.tsx



function SubgraphHealthIndicator_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-radius: 8px;\n  > div {\n    border-radius: 8px;\n  }\n  user-select: none;\n"
    ]);
    SubgraphHealthIndicator_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  gap: 7px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 12px;\n  height: 12px;\n  border-radius: 50%;\n  background: ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}







var StyledCard = (0,styled_components_browser_esm/* default */.ZP)(Card/* default */.Z).withConfig({
    componentId: "sc-231dbe63-0"
})(SubgraphHealthIndicator_templateObject());
var IndicatorWrapper = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-231dbe63-1"
})(_templateObject1());
var Dot = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
    componentId: "sc-231dbe63-2"
})(_templateObject2(), function(param) {
    var $color = param.$color, theme = param.theme;
    return theme.colors[$color];
});
var ref, ref1, ref2;
var indicator = function(t, customDescriptions) {
    return {
        delayed: {
            label: t("Delayed"),
            color: "failure",
            description: (ref = customDescriptions === null || customDescriptions === void 0 ? void 0 : customDescriptions.delayed) !== null && ref !== void 0 ? ref : t("Subgraph is currently experiencing delays due to BSC issues. Performance may suffer until subgraph is restored.")
        },
        slow: {
            label: t("Slight delay"),
            color: "warning",
            description: (ref1 = customDescriptions === null || customDescriptions === void 0 ? void 0 : customDescriptions.slow) !== null && ref1 !== void 0 ? ref1 : t("Subgraph is currently experiencing delays due to BSC issues. Performance may suffer until subgraph is restored.")
        },
        healthy: {
            label: t("Fast"),
            color: "success",
            description: (ref2 = customDescriptions === null || customDescriptions === void 0 ? void 0 : customDescriptions.healthy) !== null && ref2 !== void 0 ? ref2 : t("No issues with the subgraph.")
        }
    };
};
var getIndicator = function(sgStatus) {
    if (sgStatus === SubgraphStatus.NOT_OK) {
        return "delayed";
    }
    if (sgStatus === SubgraphStatus.WARNING) {
        return "slow";
    }
    return "healthy";
};
var SubgraphHealthIndicator = function(param) {
    var subgraphName = param.subgraphName, inline = param.inline, customDescriptions = param.customDescriptions, obeyGlobalSetting = param.obeyGlobalSetting;
    var t = (0,src/* useTranslation */.$G)().t;
    var ref = hooks_useSubgraphHealth(subgraphName), status = ref.status, currentBlock = ref.currentBlock, blockDifference = ref.blockDifference, latestBlock = ref.latestBlock;
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,hooks/* useSubgraphHealthIndicatorManager */.YF)(), 1), alwaysShowIndicator = ref1[0];
    var forceIndicatorDisplay = status === SubgraphStatus.WARNING || status === SubgraphStatus.NOT_OK;
    var showIndicator = obeyGlobalSetting && alwaysShowIndicator || forceIndicatorDisplay;
    var indicatorProps = indicator(t, customDescriptions);
    var secondRemainingBlockSync = blockDifference * config/* BSC_BLOCK_TIME */.hJ;
    var indicatorValue = getIndicator(status);
    var current = indicatorProps[indicatorValue];
    var ref2 = (0,useTooltip/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)(TooltipContent, (0,_object_spread/* default */.Z)({
        currentBlock: currentBlock,
        secondRemainingBlockSync: secondRemainingBlockSync,
        blockNumberFromSubgraph: latestBlock
    }, current)), {
        placement: "top"
    }), targetRef = ref2.targetRef, tooltipVisible = ref2.tooltipVisible, tooltip = ref2.tooltip;
    if (!latestBlock || !currentBlock || !showIndicator) {
        return null;
    }
    if (inline) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(IndicatorWrapper, {
            alignItems: "center",
            justifyContent: "flex-end",
            ref: targetRef,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Dot, {
                    $color: current.color
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    children: current.label
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Info/* default */.Z, {}),
                tooltipVisible && tooltip
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        position: "fixed",
        bottom: "55px",
        right: "5%",
        ref: targetRef,
        "data-test": "subgraph-health-indicator",
        children: [
            tooltipVisible && tooltip,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCard, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(IndicatorWrapper, {
                    alignItems: "center",
                    p: "10px",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Dot, {
                            $color: current.color
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            children: current.label
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Info/* default */.Z, {})
                    ]
                })
            })
        ]
    });
};
var TooltipContent = function(param) {
    var color = param.color, label = param.label, description = param.description, currentBlock = param.currentBlock, secondRemainingBlockSync = param.secondRemainingBlockSync, blockNumberFromSubgraph = param.blockNumberFromSubgraph;
    var t = (0,src/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(IndicatorWrapper, {
                pb: "10px",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Dot, {
                        $color: color
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        children: label
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                pb: "24px",
                children: description
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("strong", {
                        children: [
                            t("Chain Head Block"),
                            ":"
                        ]
                    }),
                    " ",
                    currentBlock
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("strong", {
                        children: [
                            t("Latest Subgraph Block"),
                            ":"
                        ]
                    }),
                    " ",
                    blockNumberFromSubgraph
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("strong", {
                        children: [
                            t("Delay"),
                            ":"
                        ]
                    }),
                    " ",
                    currentBlock - blockNumberFromSubgraph,
                    " (",
                    secondRemainingBlockSync,
                    "s)"
                ]
            })
        ]
    });
};
/* harmony default export */ var components_SubgraphHealthIndicator = (SubgraphHealthIndicator);


/***/ }),

/***/ 4057:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ limit_orders; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_instanceof.mjs
var _instanceof = __webpack_require__(82670);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./packages/swap-sdk/src/index.ts + 32 modules
var src = __webpack_require__(54346);
// EXTERNAL MODULE: ./packages/uikit/src/contexts/MatchBreakpoints/useMatchBreakpointsContext.ts
var useMatchBreakpointsContext = __webpack_require__(98946);
// EXTERNAL MODULE: ./packages/uikit/src/widgets/Modal/useModal.ts
var useModal = __webpack_require__(65528);
// EXTERNAL MODULE: ./packages/uikit/src/components/Box/Flex.tsx
var Flex = __webpack_require__(4318);
// EXTERNAL MODULE: ./packages/uikit/src/components/Box/Box.tsx
var Box = __webpack_require__(44850);
// EXTERNAL MODULE: ./packages/uikit/src/components/Button/Button.tsx + 2 modules
var Button = __webpack_require__(96293);
// EXTERNAL MODULE: ./packages/uikit/src/components/Link/Link.tsx
var Link = __webpack_require__(80421);
// EXTERNAL MODULE: ./packages/uikit/src/components/BottomDrawer/BottomDrawer.tsx
var BottomDrawer = __webpack_require__(67653);
// EXTERNAL MODULE: ./packages/localization/src/index.tsx + 5 modules
var localization_src = __webpack_require__(8253);
// EXTERNAL MODULE: ./src/components/Layout/Column.tsx
var Column = __webpack_require__(41914);
// EXTERNAL MODULE: ./src/components/CurrencyInputPanel/index.tsx + 1 modules
var CurrencyInputPanel = __webpack_require__(19527);
// EXTERNAL MODULE: ./src/components/App/index.tsx + 3 modules
var App = __webpack_require__(45460);
// EXTERNAL MODULE: ./src/components/ConnectWalletButton.tsx
var ConnectWalletButton = __webpack_require__(30621);
// EXTERNAL MODULE: ./src/components/Menu/Footer.tsx
var Footer = __webpack_require__(13625);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/jsbi/dist/jsbi-umd.js
var jsbi_umd = __webpack_require__(39499);
var jsbi_umd_default = /*#__PURE__*/__webpack_require__.n(jsbi_umd);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./src/config/constants/exchange.ts
var exchange = __webpack_require__(19838);
// EXTERNAL MODULE: ./src/hooks/useActiveWeb3React.ts
var useActiveWeb3React = __webpack_require__(64011);
// EXTERNAL MODULE: ./src/utils/wrappedCurrency.ts
var wrappedCurrency = __webpack_require__(53854);
// EXTERNAL MODULE: ./src/hooks/Tokens.ts
var Tokens = __webpack_require__(86435);
// EXTERNAL MODULE: ./src/hooks/Trades.ts + 1 modules
var Trades = __webpack_require__(23715);
;// CONCATENATED MODULE: ./src/views/LimitOrders/utils/getPriceForOneToken.ts

/**
 * Given certain amount if input and output tokens
 * calculate the price for 1 input token in terms of output tokens
 */ var getPriceForOneToken = function(inputAmount, outputAmount) {
    if (!inputAmount || !outputAmount || inputAmount.equalTo(0) || outputAmount.equalTo(0)) {
        return undefined;
    }
    return new src/* Price */.tA(inputAmount.currency, outputAmount.currency, inputAmount.raw, outputAmount.raw);
};
/* harmony default export */ var utils_getPriceForOneToken = (getPriceForOneToken);

// EXTERNAL MODULE: ./src/utils/index.ts
var utils = __webpack_require__(93293);
// EXTERNAL MODULE: ./src/utils/tryParseAmount.ts
var tryParseAmount = __webpack_require__(97938);
// EXTERNAL MODULE: ./src/state/wallet/hooks.ts
var hooks = __webpack_require__(71900);
// EXTERNAL MODULE: ./src/state/limitOrders/actions.ts
var actions = __webpack_require__(90542);
// EXTERNAL MODULE: ./src/state/limitOrders/types.ts
var types = __webpack_require__(37621);
// EXTERNAL MODULE: ./src/state/index.ts + 34 modules
var state = __webpack_require__(46506);
;// CONCATENATED MODULE: ./src/state/limitOrders/hooks.ts



















// Get desired input amount in output basis mode
var getDesiredInput = function(outputValue, exchangeRate, inputCurrency, outputCurrency, isInverted) {
    if (!outputValue || !inputCurrency || !outputCurrency) {
        return undefined;
    }
    var parsedOutAmount = (0,tryParseAmount/* default */.Z)(outputValue, isInverted ? inputCurrency : outputCurrency);
    var parsedExchangeRate = (0,tryParseAmount/* default */.Z)(exchangeRate, isInverted ? inputCurrency : outputCurrency);
    if (!parsedOutAmount || !parsedExchangeRate) {
        return undefined;
    }
    if (isInverted) {
        var invertedResultAsFraction = parsedOutAmount.asFraction.multiply(parsedExchangeRate.asFraction).multiply(jsbi_umd_default().exponentiate(exchange/* BIG_INT_TEN */.TY, jsbi_umd_default().BigInt(inputCurrency.decimals)));
        var invertedResultAsAmount = (0,_instanceof/* default */.Z)(inputCurrency, src/* Token */.WU) ? new src/* TokenAmount */.dt(inputCurrency, invertedResultAsFraction.toFixed(0)) : src/* CurrencyAmount.ether */.ih.ether(invertedResultAsFraction.toFixed(0));
        return invertedResultAsAmount;
    }
    var resultAsFraction = parsedOutAmount.asFraction.divide(parsedExchangeRate.asFraction).multiply(jsbi_umd_default().exponentiate(exchange/* BIG_INT_TEN */.TY, jsbi_umd_default().BigInt(inputCurrency.decimals)));
    var resultAsAmount = (0,_instanceof/* default */.Z)(inputCurrency, src/* Token */.WU) ? new src/* TokenAmount */.dt(inputCurrency, resultAsFraction.quotient.toString()) : src/* CurrencyAmount.ether */.ih.ether(resultAsFraction.quotient.toString());
    return resultAsAmount;
};
// Get desired output amount in input basis mode
var getDesiredOutput = function(inputValue, exchangeRate, inputCurrency, outputCurrency, isInverted) {
    if (!inputValue || !inputCurrency || !outputCurrency) {
        return undefined;
    }
    var parsedInputAmount = (0,tryParseAmount/* default */.Z)(inputValue, isInverted ? outputCurrency : inputCurrency);
    var parsedExchangeRate = (0,tryParseAmount/* default */.Z)(exchangeRate, isInverted ? inputCurrency : outputCurrency);
    if (!parsedExchangeRate || !parsedInputAmount) {
        return undefined;
    }
    if (isInverted) {
        var invertedResultAsFraction = parsedInputAmount.asFraction.multiply(jsbi_umd_default().exponentiate(exchange/* BIG_INT_TEN */.TY, jsbi_umd_default().BigInt(outputCurrency.decimals))).divide(parsedExchangeRate.asFraction);
        var invertedResultAsAmount = (0,_instanceof/* default */.Z)(outputCurrency, src/* Token */.WU) ? new src/* TokenAmount */.dt(outputCurrency, invertedResultAsFraction.toFixed(0)) : src/* CurrencyAmount.ether */.ih.ether(invertedResultAsFraction.toFixed(0));
        return invertedResultAsAmount;
    }
    var resultAsFraction = parsedInputAmount.asFraction.multiply(parsedExchangeRate.asFraction).multiply(jsbi_umd_default().exponentiate(exchange/* BIG_INT_TEN */.TY, jsbi_umd_default().BigInt(outputCurrency.decimals)));
    var resultAsAmount = (0,_instanceof/* default */.Z)(outputCurrency, src/* Token */.WU) ? new src/* TokenAmount */.dt(outputCurrency, resultAsFraction.quotient.toString()) : src/* CurrencyAmount.ether */.ih.ether(resultAsFraction.quotient.toString());
    return resultAsAmount;
};
// Just returns Redux state for limitOrders
var useOrderState = function() {
    return (0,es/* useSelector */.v9)(function(state) {
        return state.limitOrders;
    });
};
// Returns handlers to change user-defined parts of limitOrders state
var useOrderActionHandlers = function() {
    var dispatch = (0,es/* useDispatch */.I0)();
    var onCurrencySelection = (0,react.useCallback)(function(field, currency) {
        dispatch((0,actions/* selectCurrency */.j)({
            field: field,
            currencyId: (0,_instanceof/* default */.Z)(currency, src/* Token */.WU) ? currency.address : currency === src/* ETHER */.c0 ? "BNB" : ""
        }));
    }, [
        dispatch
    ]);
    var onSwitchTokens = (0,react.useCallback)(function() {
        dispatch((0,actions/* switchCurrencies */.KS)());
    }, [
        dispatch
    ]);
    var onUserInput = (0,react.useCallback)(function(field, typedValue) {
        dispatch((0,actions/* typeInput */.LC)({
            field: field,
            typedValue: typedValue
        }));
    }, [
        dispatch
    ]);
    var onChangeRateType = (0,react.useCallback)(function(rateType) {
        dispatch((0,actions/* setRateType */.sN)({
            rateType: rateType
        }));
    }, [
        dispatch
    ]);
    return {
        onSwitchTokens: onSwitchTokens,
        onCurrencySelection: onCurrencySelection,
        onUserInput: onUserInput,
        onChangeRateType: onChangeRateType
    };
};
var getErrorMessage = function(account, wrappedCurrencies, currencies, currencyBalances, parsedAmounts, trade, price, rateType) {
    if (!account) {
        return "Connect Wallet";
    }
    if (wrappedCurrencies.input && wrappedCurrencies.output && wrappedCurrencies.input.address.toLowerCase() === wrappedCurrencies.output.address.toLowerCase()) {
        return "Order not allowed";
    }
    var hasBothTokensSelected = currencies.input && currencies.output;
    if (!hasBothTokensSelected) {
        return "Select a token";
    }
    var hasAtLeastOneParsedAmount = parsedAmounts.input || parsedAmounts.output;
    var tradeIsNotAvailable = !trade || !(trade === null || trade === void 0 ? void 0 : trade.route);
    if (hasAtLeastOneParsedAmount && tradeIsNotAvailable) {
        return "Insufficient liquidity for this trade";
    }
    var someParsedAmountIsMissing = !parsedAmounts.input || !parsedAmounts.output;
    if (someParsedAmountIsMissing) {
        return "Enter an amount";
    }
    if (currencyBalances.input && currencyBalances.input.lessThan(parsedAmounts.input)) {
        return "Insufficient ".concat(currencyBalances.input.currency.symbol, " balance");
    }
    if (price) {
        if (rateType === types/* Rate.MUL */.j.MUL && (price.lessThan(trade.executionPrice.asFraction) || price.equalTo(trade.executionPrice.asFraction))) {
            return "Only possible to place sell orders above market rate";
        }
        if (rateType === types/* Rate.DIV */.j.DIV && (price.invert().greaterThan(trade.executionPrice.invert().asFraction) || price.invert().equalTo(trade.executionPrice.invert().asFraction))) {
            return "Only possible to place buy orders below market rate";
        }
    }
    return undefined;
};
// from the current swap inputs, compute the best trade and return it.
var useDerivedOrderInfo = function() {
    var ref, ref1, ref2, ref3, ref4;
    var ref5 = (0,useActiveWeb3React/* default */.Z)(), account = ref5.account, chainId = ref5.chainId;
    var ref6 = useOrderState(), independentField = ref6.independentField, basisField = ref6.basisField, typedValue = ref6.typedValue, _INPUT = ref6[types/* Field.INPUT */.g.INPUT], inputCurrencyId = _INPUT.currencyId, _OUTPUT = ref6[types/* Field.OUTPUT */.g.OUTPUT], outputCurrencyId = _OUTPUT.currencyId, rateType = ref6.rateType, inputValue = ref6.inputValue, outputValue = ref6.outputValue;
    // Get Currency objects based on currencyId strings
    var inputCurrency = (0,Tokens/* useCurrency */.U8)(inputCurrencyId);
    var outputCurrency = (0,Tokens/* useCurrency */.U8)(outputCurrencyId);
    var currencies = (0,react.useMemo)(function() {
        return {
            input: inputCurrency !== null && inputCurrency !== void 0 ? inputCurrency : undefined,
            output: outputCurrency !== null && outputCurrency !== void 0 ? outputCurrency : undefined
        };
    }, [
        inputCurrency,
        outputCurrency
    ]);
    var wrappedCurrencies = (0,react.useMemo)(function() {
        return {
            input: (0,wrappedCurrency/* wrappedCurrency */.pu)(currencies.input, chainId),
            output: (0,wrappedCurrency/* wrappedCurrency */.pu)(currencies.output, chainId)
        };
    }, [
        currencies.input,
        currencies.output,
        chainId
    ]);
    // Get user balance for selected Currencies
    var relevantTokenBalances = (0,hooks/* useCurrencyBalances */.K5)(account !== null && account !== void 0 ? account : undefined, [
        inputCurrency !== null && inputCurrency !== void 0 ? inputCurrency : undefined,
        outputCurrency !== null && outputCurrency !== void 0 ? outputCurrency : undefined, 
    ]);
    var currencyBalances = {
        input: relevantTokenBalances[0],
        output: relevantTokenBalances[1]
    };
    // Get CurrencyAmount for the inputCurrency amount specified by user
    var inputAmount = (0,react.useMemo)(function() {
        return (0,tryParseAmount/* default */.Z)(inputValue, inputCurrency !== null && inputCurrency !== void 0 ? inputCurrency : undefined);
    }, [
        inputValue,
        inputCurrency
    ]);
    // Get CurrencyAmount for the outputCurrency amount specified by user
    var outputAmount = (0,react.useMemo)(function() {
        return (0,tryParseAmount/* default */.Z)(outputValue, outputCurrency !== null && outputCurrency !== void 0 ? outputCurrency : undefined);
    }, [
        outputValue,
        outputCurrency
    ]);
    // Whether user modified the INPUT field most recently (also default initial state)
    var isExactIn = independentField === types/* Field.INPUT */.g.INPUT;
    // Whether to base calculations on output field
    var isOutputBasis = basisField === types/* Field.OUTPUT */.g.OUTPUT;
    // Whether user modified the PRICE field most recently
    var isDesiredRateUpdate = independentField === types/* Field.PRICE */.g.PRICE;
    // Get the amount of outputCurrency you'd receive at the desired price
    var desiredOutputAsCurrencyAmount = isDesiredRateUpdate ? getDesiredOutput(inputValue, typedValue, inputCurrency, outputCurrency, rateType === types/* Rate.DIV */.j.DIV) : undefined;
    var desiredInputAsCurrencyAmount = isDesiredRateUpdate ? getDesiredInput(outputValue, typedValue, inputCurrency, outputCurrency, rateType === types/* Rate.DIV */.j.DIV) : undefined;
    // Convert output to string representation to parse later
    var desiredOutputAsString = isDesiredRateUpdate && desiredOutputAsCurrencyAmount ? desiredOutputAsCurrencyAmount === null || desiredOutputAsCurrencyAmount === void 0 ? void 0 : desiredOutputAsCurrencyAmount.toSignificant(6) : typedValue;
    var ref7;
    // If independentField === Field.PRICE -> this won't be used
    var parsedTypedAmount = !isDesiredRateUpdate ? (0,tryParseAmount/* default */.Z)(typedValue, (ref7 = isExactIn ? inputCurrency : outputCurrency) !== null && ref7 !== void 0 ? ref7 : undefined) : undefined;
    // If not price - cast input or output typing to CurrencyAmount
    // if price - whatever amount of tokens received on the desired price
    var tradeAmount = isDesiredRateUpdate ? isOutputBasis ? outputAmount : (0,tryParseAmount/* default */.Z)(desiredOutputAsString, outputCurrency) : (0,tryParseAmount/* default */.Z)(typedValue, isExactIn ? inputCurrency : outputCurrency);
    // Get trade object
    // gonna be null if not isExactIn or if there is no outputCurrency selected
    var bestTradeExactIn = (0,Trades/* useTradeExactIn */.AU)(isExactIn ? tradeAmount : undefined, outputCurrency);
    // Works similarly to swap when you modify outputCurrency
    // But also is used when desired rate is modified
    // in other words it looks for a trade of inputCurrency for whatever the amount of tokens would be at desired rate
    var bestTradeExactOut = (0,Trades/* useTradeExactOut */["in"])(inputCurrency, !isExactIn || isOutputBasis ? tradeAmount : undefined);
    var trade = isExactIn ? bestTradeExactIn : bestTradeExactOut;
    // Get swap price for single token disregarding slippage and price impact
    // needed for chart's latest value
    var oneInputToken = (0,tryParseAmount/* default */.Z)("1", currencies.input);
    var singleTokenTrade = (0,Trades/* useTradeExactIn */.AU)(oneInputToken, currencies.output);
    var singleTokenPrice = parseFloat(singleTokenTrade === null || singleTokenTrade === void 0 ? void 0 : (ref = singleTokenTrade.executionPrice) === null || ref === void 0 ? void 0 : ref.toSignificant(6));
    var inverseSingleTokenPrice = 1 / singleTokenPrice;
    // Get "final" amounts
    var parsedAmounts = (0,react.useMemo)(function() {
        // Use trade amount as default
        var input = trade === null || trade === void 0 ? void 0 : trade.inputAmount;
        if (!isOutputBasis) {
            // If we're not in output basis mode then we're in input basis mode
            // hence - no matter what keep input as specified by user
            input = inputAmount;
        } else if (independentField === types/* Field.INPUT */.g.INPUT) {
            // If user touching input field -> whatever they type currently
            input = parsedTypedAmount;
        } else if (isDesiredRateUpdate) {
            // If user modifies the price AND is wishing for specific output amount -> hypothetical input amount at better price
            input = desiredInputAsCurrencyAmount;
        }
        // Use trade amount as default
        // If we're in output basis mode - no matter what keep output as specified by user
        var output;
        if (isOutputBasis) {
            output = outputAmount;
        } else if (independentField === types/* Field.OUTPUT */.g.OUTPUT) {
            // If user touching input field -> whatever they type currently
            output = parsedTypedAmount;
        } else if (isDesiredRateUpdate) {
            // If user modifies the price AND is wishing for specific input amount -> hypothetical input amount at better price
            output = desiredOutputAsCurrencyAmount;
        } else {
            output = trade === null || trade === void 0 ? void 0 : trade.outputAmount;
        }
        return {
            input: input,
            output: output
        };
    }, [
        independentField,
        parsedTypedAmount,
        inputAmount,
        outputAmount,
        trade,
        isDesiredRateUpdate,
        isOutputBasis,
        desiredInputAsCurrencyAmount,
        desiredOutputAsCurrencyAmount, 
    ]);
    // Calculate the price for specified swap
    var price = (0,react.useMemo)(function() {
        return utils_getPriceForOneToken(parsedAmounts.input, parsedAmounts.output);
    }, [
        parsedAmounts.input,
        parsedAmounts.output
    ]);
    var ref8, ref9, ref10, ref11;
    // Formatted amounts to use in the UI
    var formattedAmounts = {
        input: !isOutputBasis && inputValue && inputValue !== "" ? inputValue : (ref8 = (ref1 = parsedAmounts.input) === null || ref1 === void 0 ? void 0 : ref1.toSignificant(6)) !== null && ref8 !== void 0 ? ref8 : "",
        output: isOutputBasis && outputValue && outputValue !== "" ? outputValue : (ref9 = (ref2 = parsedAmounts.output) === null || ref2 === void 0 ? void 0 : ref2.toSignificant(6)) !== null && ref9 !== void 0 ? ref9 : "",
        price: independentField === types/* Field.PRICE */.g.PRICE ? typedValue : rateType === types/* Rate.MUL */.j.MUL ? (ref10 = price === null || price === void 0 ? void 0 : price.toSignificant(6)) !== null && ref10 !== void 0 ? ref10 : "" : (ref11 = price === null || price === void 0 ? void 0 : price.invert().toSignificant(6)) !== null && ref11 !== void 0 ? ref11 : ""
    };
    // Get raw amounts that will be used in smart contract call
    var rawAmounts = (0,react.useMemo)(function() {
        var ref, ref1;
        return {
            input: inputCurrency ? (ref = parsedAmounts.input) === null || ref === void 0 ? void 0 : ref.multiply(jsbi_umd_default().exponentiate(exchange/* BIG_INT_TEN */.TY, jsbi_umd_default().BigInt(inputCurrency.decimals))).toFixed(0) : undefined,
            output: outputCurrency ? (ref1 = parsedAmounts.output) === null || ref1 === void 0 ? void 0 : ref1.multiply(jsbi_umd_default().exponentiate(exchange/* BIG_INT_TEN */.TY, jsbi_umd_default().BigInt(outputCurrency.decimals))).toFixed(0) : undefined
        };
    }, [
        inputCurrency,
        outputCurrency,
        parsedAmounts
    ]);
    var _obj;
    return {
        currencies: currencies,
        currencyBalances: currencyBalances,
        inputError: getErrorMessage(account, wrappedCurrencies, currencies, currencyBalances, parsedAmounts, trade, price, rateType),
        formattedAmounts: formattedAmounts,
        trade: trade !== null && trade !== void 0 ? trade : undefined,
        parsedAmounts: parsedAmounts,
        price: price,
        rawAmounts: rawAmounts,
        wrappedCurrencies: wrappedCurrencies,
        singleTokenPrice: (_obj = {}, (0,_define_property/* default */.Z)(_obj, (ref3 = wrappedCurrencies.input) === null || ref3 === void 0 ? void 0 : ref3.address, singleTokenPrice), (0,_define_property/* default */.Z)(_obj, (ref4 = wrappedCurrencies.output) === null || ref4 === void 0 ? void 0 : ref4.address, inverseSingleTokenPrice), _obj),
        currencyIds: {
            input: inputCurrencyId,
            output: outputCurrencyId
        }
    };
};
function parseTokenAmountURLParameter(urlParam) {
    return typeof urlParam === "string" && !Number.isNaN(parseFloat(urlParam)) ? urlParam : "";
}
function parseIndependentFieldURLParameter(urlParam) {
    return typeof urlParam === "string" && urlParam.toLowerCase() === "output" ? types/* Field.OUTPUT */.g.OUTPUT : types/* Field.INPUT */.g.INPUT;
}
function parseCurrencyFromURLParameter(urlParam) {
    if (typeof urlParam === "string") {
        var valid = (0,utils/* isAddress */.UJ)(urlParam);
        if (valid) return valid;
        if (urlParam.toUpperCase() === "BNB") return "BNB";
        if (valid === false) return "BNB";
    }
    return "";
}
// TODO: combine with swap's version but use generic type. Same for helpers above
// Note: swap has recipient and other things. Merging these 2 would probably be much easier if we get rid of recipient
// Also the whole thing doesn't make sense, in swap inputValue is not initialized but typedValue is. WTF
var queryParametersToSwapState = function(parsedQs) {
    var inputCurrency = parseCurrencyFromURLParameter(parsedQs.inputCurrency) || exchange/* DEFAULT_INPUT_CURRENCY */.VN;
    var outputCurrency = parseCurrencyFromURLParameter(parsedQs.outputCurrency) || exchange/* DEFAULT_OUTPUT_CURRENCY */.g$;
    if (inputCurrency === outputCurrency) {
        if (typeof parsedQs.outputCurrency === "string") {
            inputCurrency = "";
        } else {
            outputCurrency = "";
        }
    }
    var _obj;
    return _obj = {}, (0,_define_property/* default */.Z)(_obj, types/* Field.INPUT */.g.INPUT, {
        currencyId: inputCurrency
    }), (0,_define_property/* default */.Z)(_obj, types/* Field.OUTPUT */.g.OUTPUT, {
        currencyId: outputCurrency
    }), (0,_define_property/* default */.Z)(_obj, "inputValue", ""), (0,_define_property/* default */.Z)(_obj, "outputValue", ""), (0,_define_property/* default */.Z)(_obj, "typedValue", parseTokenAmountURLParameter(parsedQs.exactAmount)), (0,_define_property/* default */.Z)(_obj, "independentField", parseIndependentFieldURLParameter(parsedQs.exactField)), (0,_define_property/* default */.Z)(_obj, "basisField", parseIndependentFieldURLParameter(parsedQs.exactField)), (0,_define_property/* default */.Z)(_obj, "rateType", types/* Rate.MUL */.j.MUL), _obj;
};
// updates the swap state to use the defaults for a given network
var useDefaultsFromURLSearch = function() {
    var chainId = (0,useActiveWeb3React/* default */.Z)().chainId;
    var dispatch = (0,state/* useAppDispatch */.TL)();
    var query = (0,next_router.useRouter)().query;
    var ref = (0,react.useState)(), result = ref[0], setResult = ref[1];
    (0,react.useEffect)(function() {
        if (!chainId) return;
        var parsed = queryParametersToSwapState(query);
        dispatch((0,actions/* replaceLimitOrdersState */.sQ)(parsed));
        setResult({
            inputCurrencyId: parsed[types/* Field.INPUT */.g.INPUT].currencyId,
            outputCurrencyId: parsed[types/* Field.OUTPUT */.g.OUTPUT].currencyId
        });
    }, [
        dispatch,
        chainId,
        query
    ]);
    return result;
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@ethersproject/bignumber/lib.esm/bignumber.js
var bignumber = __webpack_require__(2593);
// EXTERNAL MODULE: ./src/state/transactions/hooks.tsx
var transactions_hooks = __webpack_require__(55892);
// EXTERNAL MODULE: ./node_modules/swr/dist/index.mjs
var dist = __webpack_require__(8100);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./src/config/constants/index.ts
var constants = __webpack_require__(3862);
// EXTERNAL MODULE: ./src/utils/localStorageOrders.ts
var localStorageOrders = __webpack_require__(15655);
// EXTERNAL MODULE: ./src/hooks/limitOrders/useGelatoLimitOrdersLib.ts
var useGelatoLimitOrdersLib = __webpack_require__(19508);
// EXTERNAL MODULE: ./node_modules/lodash/orderBy.js
var orderBy = __webpack_require__(75472);
var orderBy_default = /*#__PURE__*/__webpack_require__.n(orderBy);
;// CONCATENATED MODULE: ./src/views/LimitOrders/types.ts
var ORDER_CATEGORY;
(function(ORDER_CATEGORY) {
    ORDER_CATEGORY[ORDER_CATEGORY["Open"] = 0] = "Open";
    ORDER_CATEGORY[ORDER_CATEGORY["History"] = 1] = "History";
})(ORDER_CATEGORY || (ORDER_CATEGORY = {}));
var LimitOrderStatus;
(function(LimitOrderStatus) {
    LimitOrderStatus["OPEN"] = "open";
    LimitOrderStatus["CANCELLED"] = "cancelled";
    LimitOrderStatus["EXECUTED"] = "executed";
})(LimitOrderStatus || (LimitOrderStatus = {}));

;// CONCATENATED MODULE: ./src/views/LimitOrders/hooks/useGelatoLimitOrdersHistory.ts












var OPEN_ORDERS_SWR_KEY = [
    "gelato",
    "openOrders"
];
var EXECUTED_CANCELLED_ORDERS_SWR_KEY = [
    "gelato",
    "cancelledExecutedOrders"
];
function newOrdersFirst(a, b) {
    return Number(b.updatedAt) - Number(a.updatedAt);
}
var isOrderUpdated = function(oldOrder, newOrder) {
    return newOrder ? Number(oldOrder.updatedAt) < Number(newOrder.updatedAt) : false;
};
function syncOrderToLocalStorage(_) {
    return _syncOrderToLocalStorage.apply(this, arguments);
}
function _syncOrderToLocalStorage() {
    _syncOrderToLocalStorage = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param) {
        var gelatoLimitOrders, chainId, account, orders, syncStatuses, allOrdersLS, lsOrdersHashSet, newOrders, typeOrdersLS, i, confOrder, ref, graphOrder;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    gelatoLimitOrders = param.gelatoLimitOrders, chainId = param.chainId, account = param.account, orders = param.orders, syncStatuses = param.syncStatuses;
                    allOrdersLS = (0,localStorageOrders/* getLSOrders */.QR)(chainId, account);
                    lsOrdersHashSet = (0,localStorageOrders/* hashOrderSet */.AG)(allOrdersLS);
                    newOrders = orders.filter(function(order) {
                        return !lsOrdersHashSet.has((0,localStorageOrders/* hashOrder */.r6)(order));
                    });
                    (0,localStorageOrders/* saveOrders */.ZJ)(chainId, account, newOrders);
                    typeOrdersLS = syncStatuses ? allOrdersLS.filter(function(order) {
                        return syncStatuses.some(function(type) {
                            return type === order.status;
                        });
                    }) : [];
                    i = 0;
                case 7:
                    if (!(i < typeOrdersLS.length)) {
                        _ctx.next = 33;
                        break;
                    }
                    confOrder = typeOrdersLS[i];
                    _ctx.prev = 9;
                    ;
                    if (!((ref = orders.find(function(order) {
                        return confOrder.id.toLowerCase() === order.id.toLowerCase();
                    })) !== null && ref !== void 0)) {
                        _ctx.next = 15;
                        break;
                    }
                    _ctx.t0 = ref;
                    _ctx.next = 23;
                    break;
                case 15:
                    if (!gelatoLimitOrders) {
                        _ctx.next = 21;
                        break;
                    }
                    _ctx.next = 18;
                    return gelatoLimitOrders.getOrder(confOrder.id);
                case 18:
                    _ctx.t1 = _ctx.sent;
                    _ctx.next = 22;
                    break;
                case 21:
                    _ctx.t1 = null;
                case 22:
                    _ctx.t0 = // eslint-disable-next-line no-await-in-loop
                    (_ctx.t1);
                case 23:
                    graphOrder = _ctx.t0;
                    if (isOrderUpdated(confOrder, graphOrder)) {
                        (0,localStorageOrders/* saveOrder */.TR)(chainId, account, graphOrder);
                    }
                    _ctx.next = 30;
                    break;
                case 27:
                    _ctx.prev = 27;
                    _ctx.t2 = _ctx["catch"](9);
                    console.error("Error fetching order from subgraph", _ctx.t2);
                case 30:
                    i++;
                    _ctx.next = 7;
                    break;
                case 33:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                9,
                27
            ]
        ]);
    }));
    return _syncOrderToLocalStorage.apply(this, arguments);
}
var useOpenOrders = function(turnOn) {
    var ref = (0,useActiveWeb3React/* default */.Z)(), account = ref.account, chainId = ref.chainId;
    var gelatoLimitOrders = (0,useGelatoLimitOrdersLib/* default */.Z)();
    var startFetch = turnOn && gelatoLimitOrders && account && chainId;
    var data = (0,dist/* default */.ZP)(startFetch ? OPEN_ORDERS_SWR_KEY : null, (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var orders, openOrdersLS, pendingOrdersLS;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return gelatoLimitOrders.getOpenOrders(account.toLowerCase(), false);
                case 3:
                    orders = _ctx.sent;
                    _ctx.next = 6;
                    return syncOrderToLocalStorage({
                        orders: orders,
                        chainId: chainId,
                        account: account,
                        syncStatuses: [
                            LimitOrderStatus.OPEN
                        ],
                        gelatoLimitOrders: gelatoLimitOrders
                    });
                case 6:
                    _ctx.next = 11;
                    break;
                case 8:
                    _ctx.prev = 8;
                    _ctx.t0 = _ctx["catch"](0);
                    console.error("Error fetching open orders from subgraph", _ctx.t0);
                case 11:
                    openOrdersLS = (0,localStorageOrders/* getLSOrders */.QR)(chainId, account).filter(function(order) {
                        return order.status === LimitOrderStatus.OPEN;
                    });
                    pendingOrdersLS = (0,localStorageOrders/* getLSOrders */.QR)(chainId, account, true);
                    return _ctx.abrupt("return", (0,_to_consumable_array/* default */.Z)(openOrdersLS.filter(function(order) {
                        var orderCancelled = pendingOrdersLS.filter(function(pendingOrder) {
                            return pendingOrder.status === LimitOrderStatus.CANCELLED;
                        }).find(function(pendingOrder) {
                            return pendingOrder.id.toLowerCase() === order.id.toLowerCase();
                        });
                        return !orderCancelled;
                    })).concat((0,_to_consumable_array/* default */.Z)(pendingOrdersLS.filter(function(order) {
                        return order.status === LimitOrderStatus.OPEN;
                    }))).sort(newOrdersFirst));
                case 14:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                8
            ]
        ]);
    })), {
        refreshInterval: constants/* SLOW_INTERVAL */.KI
    }).data;
    return startFetch ? data : [];
};
var useHistoryOrders = function(turnOn) {
    var ref = (0,useActiveWeb3React/* default */.Z)(), account = ref.account, chainId = ref.chainId;
    var gelatoLimitOrders = (0,useGelatoLimitOrdersLib/* default */.Z)();
    var startFetch = turnOn && gelatoLimitOrders && account && chainId;
    var data = (0,dist/* default */.ZP)(startFetch ? EXECUTED_CANCELLED_ORDERS_SWR_KEY : null, (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var acc, ref, canOrders, exeOrders, executedOrdersLS, cancelledOrdersLS, pendingCancelledOrdersLS;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    acc = account.toLowerCase();
                    _ctx.t0 = _sliced_to_array/* default */.Z;
                    _ctx.next = 5;
                    return Promise.all([
                        gelatoLimitOrders.getCancelledOrders(acc, false),
                        gelatoLimitOrders.getExecutedOrders(acc, false), 
                    ]);
                case 5:
                    _ctx.t1 = _ctx.sent;
                    ref = (0, _ctx.t0)(_ctx.t1, 2);
                    canOrders = ref[0];
                    exeOrders = ref[1];
                    _ctx.next = 11;
                    return syncOrderToLocalStorage({
                        orders: (0,_to_consumable_array/* default */.Z)(canOrders).concat((0,_to_consumable_array/* default */.Z)(exeOrders)),
                        chainId: chainId,
                        account: account
                    });
                case 11:
                    _ctx.next = 16;
                    break;
                case 13:
                    _ctx.prev = 13;
                    _ctx.t2 = _ctx["catch"](0);
                    console.error("Error fetching history orders from subgraph", _ctx.t2);
                case 16:
                    executedOrdersLS = (0,localStorageOrders/* getLSOrders */.QR)(chainId, account).filter(function(order) {
                        return order.status === LimitOrderStatus.EXECUTED;
                    });
                    cancelledOrdersLS = (0,localStorageOrders/* getLSOrders */.QR)(chainId, account).filter(function(order) {
                        return order.status === LimitOrderStatus.CANCELLED;
                    });
                    pendingCancelledOrdersLS = (0,localStorageOrders/* getLSOrders */.QR)(chainId, account, true).filter(function(order) {
                        return order.status === LimitOrderStatus.CANCELLED;
                    });
                    return _ctx.abrupt("return", (0,_to_consumable_array/* default */.Z)(pendingCancelledOrdersLS).concat((0,_to_consumable_array/* default */.Z)(cancelledOrdersLS), (0,_to_consumable_array/* default */.Z)(executedOrdersLS)).sort(newOrdersFirst));
                case 20:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                13
            ]
        ]);
    })), {
        refreshInterval: constants/* SLOW_INTERVAL */.KI
    }).data;
    return startFetch ? data : [];
};
function useGelatoLimitOrdersHistory(orderCategory) {
    var historyOrders = useHistoryOrders(orderCategory === ORDER_CATEGORY.History);
    var openOrders = useOpenOrders(orderCategory === ORDER_CATEGORY.Open);
    var orders = (0,react.useMemo)(function() {
        return orderCategory === ORDER_CATEGORY.Open ? openOrders : historyOrders;
    }, [
        orderCategory,
        openOrders,
        historyOrders
    ]);
    return (0,react.useMemo)(function() {
        return Array.isArray(orders) ? orderBy_default()(orders, function(order) {
            return parseInt(order.createdAt);
        }, "desc") : orders;
    }, [
        orders
    ]);
};

;// CONCATENATED MODULE: ./src/hooks/limitOrders/useGelatoLimitOrdersHandlers.ts













var useGelatoLimitOrdersHandlers = function() {
    var ref = (0,useActiveWeb3React/* default */.Z)(), chainId = ref.chainId, account = ref.account;
    var mutate = (0,dist/* useSWRConfig */.kY)().mutate;
    var gelatoLimitOrders = (0,useGelatoLimitOrdersLib/* default */.Z)();
    var addTransaction = (0,transactions_hooks/* useTransactionAdder */.h7)();
    var ref1 = useOrderActionHandlers(), onSwitchTokens = ref1.onSwitchTokens, onCurrencySelection = ref1.onCurrencySelection, onUserInput = ref1.onUserInput, onChangeRateType = ref1.onChangeRateType;
    var handleLimitOrderSubmission = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(orderToSubmit, overrides) {
            var ref, witness, payload, order, tx, now;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (gelatoLimitOrders) {
                            _ctx.next = 2;
                            break;
                        }
                        throw new Error("Could not reach Gelato Limit Orders library");
                    case 2:
                        if (chainId) {
                            _ctx.next = 4;
                            break;
                        }
                        throw new Error("No chainId");
                    case 4:
                        if (gelatoLimitOrders === null || gelatoLimitOrders === void 0 ? void 0 : gelatoLimitOrders.signer) {
                            _ctx.next = 6;
                            break;
                        }
                        throw new Error("No signer");
                    case 6:
                        _ctx.next = 8;
                        return gelatoLimitOrders.encodeLimitOrderSubmissionWithSecret(orderToSubmit.inputToken, orderToSubmit.outputToken, orderToSubmit.inputAmount, orderToSubmit.outputAmount, orderToSubmit.owner);
                    case 8:
                        ref = _ctx.sent;
                        witness = ref.witness;
                        payload = ref.payload;
                        order = ref.order;
                        _ctx.next = 14;
                        return gelatoLimitOrders.signer.sendTransaction((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, overrides !== null && overrides !== void 0 ? overrides : {}), {
                            to: payload.to,
                            data: payload.data,
                            value: bignumber/* BigNumber.from */.O$.from(payload.value)
                        }));
                    case 14:
                        tx = _ctx.sent;
                        now = Math.round(Date.now() / 1000);
                        addTransaction(tx, {
                            summary: "Order submission",
                            type: "limit-order-submission",
                            order: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, order), {
                                createdTxHash: tx === null || tx === void 0 ? void 0 : tx.hash.toLowerCase(),
                                witness: witness,
                                status: "open",
                                updatedAt: now.toString()
                            })
                        });
                        mutate(OPEN_ORDERS_SWR_KEY);
                        mutate(EXECUTED_CANCELLED_ORDERS_SWR_KEY);
                        return _ctx.abrupt("return", tx);
                    case 20:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(orderToSubmit, overrides) {
            return _ref.apply(this, arguments);
        };
    }(), [
        addTransaction,
        chainId,
        gelatoLimitOrders,
        mutate
    ]);
    var handleLimitOrderCancellation = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(orderToCancel, orderDetails, overrides) {
            var checkIfOrderExists, tx, now, summary;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (gelatoLimitOrders) {
                            _ctx.next = 2;
                            break;
                        }
                        throw new Error("Could not reach Gelato Limit Orders library");
                    case 2:
                        if (chainId) {
                            _ctx.next = 4;
                            break;
                        }
                        throw new Error("No chainId");
                    case 4:
                        if (account) {
                            _ctx.next = 6;
                            break;
                        }
                        throw new Error("No account");
                    case 6:
                        checkIfOrderExists = Boolean(orderToCancel.module && orderToCancel.inputToken && orderToCancel.owner && orderToCancel.witness && orderToCancel.data);
                        _ctx.next = 9;
                        return gelatoLimitOrders.cancelLimitOrder(orderToCancel, checkIfOrderExists, overrides !== null && overrides !== void 0 ? overrides : {
                            gasLimit: 2000000
                        });
                    case 9:
                        tx = _ctx.sent;
                        now = Math.round(Date.now() / 1000);
                        summary = orderDetails ? "Order cancellation: ".concat(orderDetails.inputAmount, " ").concat(orderDetails.inputTokenSymbol, " for ").concat(orderDetails.outputAmount, " ").concat(orderDetails.outputTokenSymbol) : "Order cancellation";
                        addTransaction(tx, {
                            summary: summary,
                            type: "limit-order-cancellation",
                            order: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, orderToCancel), {
                                updatedAt: now.toString(),
                                status: "cancelled",
                                cancelledTxHash: tx === null || tx === void 0 ? void 0 : tx.hash.toLowerCase()
                            })
                        });
                        mutate(OPEN_ORDERS_SWR_KEY);
                        mutate(EXECUTED_CANCELLED_ORDERS_SWR_KEY);
                        return _ctx.abrupt("return", tx);
                    case 16:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(orderToCancel, orderDetails, overrides) {
            return _ref.apply(this, arguments);
        };
    }(), [
        gelatoLimitOrders,
        chainId,
        account,
        addTransaction,
        mutate
    ]);
    var handleInput = (0,react.useCallback)(function(field, value) {
        onUserInput(field, value);
    }, [
        onUserInput
    ]);
    var handleCurrencySelection = (0,react.useCallback)(function(field, currency) {
        onCurrencySelection(field, currency);
    }, [
        onCurrencySelection
    ]);
    var handleSwitchTokens = (0,react.useCallback)(function() {
        onSwitchTokens();
    }, [
        onSwitchTokens
    ]);
    var handleRateType = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(rateType, price) {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (rateType === types/* Rate.MUL */.j.MUL) {
                            if (price) onUserInput(types/* Field.PRICE */.g.PRICE, price.invert().toSignificant(6));
                            onChangeRateType(types/* Rate.DIV */.j.DIV);
                        } else {
                            if (price) onUserInput(types/* Field.PRICE */.g.PRICE, price.toSignificant(6));
                            onChangeRateType(types/* Rate.MUL */.j.MUL);
                        }
                    case 1:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(rateType, price) {
            return _ref.apply(this, arguments);
        };
    }(), [
        onChangeRateType,
        onUserInput
    ]);
    return {
        handleLimitOrderSubmission: handleLimitOrderSubmission,
        handleLimitOrderCancellation: handleLimitOrderCancellation,
        handleInput: handleInput,
        handleCurrencySelection: handleCurrencySelection,
        handleSwitchTokens: handleSwitchTokens,
        handleRateType: handleRateType
    };
};
/* harmony default export */ var limitOrders_useGelatoLimitOrdersHandlers = (useGelatoLimitOrdersHandlers);

;// CONCATENATED MODULE: ./src/hooks/limitOrders/useGelatoLimitOrders.ts


var useGelatoLimitOrders = function() {
    var derivedOrderInfo = useDerivedOrderInfo();
    var orderState = useOrderState();
    var handlers = limitOrders_useGelatoLimitOrdersHandlers();
    return {
        handlers: handlers,
        derivedOrderInfo: derivedOrderInfo,
        orderState: orderState
    };
};
/* harmony default export */ var limitOrders_useGelatoLimitOrders = (useGelatoLimitOrders);

// EXTERNAL MODULE: ./node_modules/@ethersproject/units/lib.esm/index.js + 1 modules
var lib_esm = __webpack_require__(61744);
// EXTERNAL MODULE: ./src/state/user/hooks/index.tsx
var user_hooks = __webpack_require__(68605);
;// CONCATENATED MODULE: ./src/hooks/limitOrders/useGasOverhead.ts












function useGasOverhead(inputAmount, outputAmount, rateType) {
    var chainId = (0,useActiveWeb3React/* default */.Z)().chainId;
    var gasPrice = (0,user_hooks/* useGasPrice */.Fh)();
    var requiredGas = (0,lib_esm/* formatUnits */.bM)(gasPrice ? bignumber/* BigNumber.from */.O$.from(gasPrice).mul(exchange/* GENERIC_GAS_LIMIT_ORDER_EXECUTION */.q3) : "0");
    var requiredGasAsCurrencyAmount = (0,tryParseAmount/* default */.Z)(requiredGas, src/* ETHER */.c0);
    var inputIsBNB = (inputAmount === null || inputAmount === void 0 ? void 0 : inputAmount.currency.symbol) === "BNB";
    var gasCostInInputTokens = (0,Trades/* useTradeExactIn */.AU)(requiredGasAsCurrencyAmount, inputIsBNB ? null : inputAmount === null || inputAmount === void 0 ? void 0 : inputAmount.currency);
    var bufferedOutputAmount = (0,react.useMemo)(function() {
        if (inputIsBNB) return requiredGasAsCurrencyAmount;
        if (!gasCostInInputTokens || !(gasCostInInputTokens === null || gasCostInInputTokens === void 0 ? void 0 : gasCostInInputTokens.outputAmount)) return undefined;
        // Add 2000 BPS on top (20%) to account for gas price fluctuations
        var margin = gasCostInInputTokens.outputAmount.asFraction.multiply(2000).divide(10000);
        var adjustedGas = gasCostInInputTokens.outputAmount.asFraction.add(margin);
        var adjustedGasInWei = adjustedGas.multiply(src/* JSBI.exponentiate */.QA.exponentiate(exchange/* BIG_INT_TEN */.TY, src/* JSBI.BigInt */.QA.BigInt(gasCostInInputTokens.outputAmount.currency.decimals)));
        if ((0,_instanceof/* default */.Z)(gasCostInInputTokens.outputAmount.currency, src/* Token */.WU)) {
            return new src/* TokenAmount */.dt(gasCostInInputTokens.outputAmount.currency, adjustedGasInWei.toFixed(0));
        }
        return undefined;
    }, [
        gasCostInInputTokens,
        requiredGasAsCurrencyAmount,
        inputIsBNB
    ]);
    var realInputAmount = (0,react.useMemo)(function() {
        return bufferedOutputAmount && inputAmount && inputAmount.greaterThan(bufferedOutputAmount) && inputAmount.subtract(bufferedOutputAmount);
    }, [
        bufferedOutputAmount,
        inputAmount
    ]);
    var realExecutionPrice = (0,react.useMemo)(function() {
        if (!inputAmount || !gasCostInInputTokens && !inputIsBNB || !realInputAmount || !outputAmount) return null;
        if (inputIsBNB && requiredGasAsCurrencyAmount.greaterThan(inputAmount.asFraction)) return undefined;
        if (gasCostInInputTokens && gasCostInInputTokens.outputAmount.greaterThan(inputAmount.asFraction)) return undefined;
        return utils_getPriceForOneToken(realInputAmount, outputAmount);
    }, [
        realInputAmount,
        outputAmount,
        inputAmount,
        gasCostInInputTokens,
        inputIsBNB,
        requiredGasAsCurrencyAmount
    ]);
    var realExecutionPriceAsString = (0,react.useMemo)(function() {
        if (!realExecutionPrice) return "never executes";
        return rateType === types/* Rate.DIV */.j.DIV ? realExecutionPrice.invert().toSignificant(6) : realExecutionPrice.toSignificant(6);
    }, [
        rateType,
        realExecutionPrice
    ]);
    return chainId ? {
        realExecutionPrice: realExecutionPrice,
        gasPrice: gasPrice,
        realExecutionPriceAsString: realExecutionPriceAsString
    } : {
        realExecutionPrice: undefined,
        realExecutionPriceAsString: undefined,
        gasPrice: undefined
    };
};

// EXTERNAL MODULE: ./src/hooks/useTheme.ts
var useTheme = __webpack_require__(23917);
// EXTERNAL MODULE: ./src/hooks/useApproveCallback.ts + 1 modules
var useApproveCallback = __webpack_require__(50165);
// EXTERNAL MODULE: ./src/utils/maxAmountSpend.ts
var maxAmountSpend = __webpack_require__(45131);
// EXTERNAL MODULE: ./src/views/Swap/components/Chart/PriceChartContainer.tsx + 6 modules
var PriceChartContainer = __webpack_require__(62367);
// EXTERNAL MODULE: ./node_modules/@web3-react/core/dist/core.esm.js
var core_esm = __webpack_require__(77044);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./packages/uikit/src/widgets/Modal/styles.tsx
var styles = __webpack_require__(9355);
// EXTERNAL MODULE: ./packages/uikit/src/components/Heading/Heading.tsx + 1 modules
var Heading = __webpack_require__(59750);
// EXTERNAL MODULE: ./packages/uikit/src/components/Text/Text.tsx
var Text = __webpack_require__(97114);
// EXTERNAL MODULE: ./packages/uikit/src/components/Checkbox/Checkbox.tsx + 1 modules
var Checkbox = __webpack_require__(19731);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
;// CONCATENATED MODULE: ./src/components/DisclaimerModal/index.tsx



function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n  padding-bottom: 24px;\n  padding-top: 24px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var GradientModalHeader = (0,styled_components_browser_esm/* default */.ZP)(styles/* ModalHeader */.xB).withConfig({
    componentId: "sc-a3f61524-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.gradients.bubblegum;
});
// TODO: Copy from src/views/Predictions/components/RiskDisclaimer.tsx
// Will replace that with this modal.
var DisclaimerModal = function(param) {
    var id = param.id, onSuccess = param.onSuccess, onDismiss = param.onDismiss, checks = param.checks, header = param.header, subtitle = param.subtitle;
    var ref = (0,react.useState)(checks || []), checkState = ref[0], setCheckState = ref[1];
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var handleSetAcknowledgeRisk = (0,react.useCallback)(function(currentKey) {
        var newCheckState = checkState.map(function(check) {
            if (currentKey === check.key) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, check), {
                    value: !check.value
                });
            }
            return check;
        });
        setCheckState(newCheckState);
    }, [
        checkState
    ]);
    var handleConfirm = (0,react.useCallback)(function() {
        onSuccess();
        onDismiss();
    }, [
        onSuccess,
        onDismiss
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* ModalContainer */.F0, {
        title: t("Welcome!"),
        $minWidth: "320px",
        id: id,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(GradientModalHeader, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* ModalTitle */.r6, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                        scale: "lg",
                        children: t("Welcome!")
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* ModalBody */.fe, {
                p: "24px",
                maxWidth: [
                    "100%",
                    "100%",
                    "100%",
                    "400px"
                ],
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        maxHeight: "300px",
                        overflowY: "auto",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                as: "h3",
                                mb: "24px",
                                children: header
                            }),
                            subtitle && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                as: "p",
                                color: "textSubtle",
                                mb: "24px",
                                children: subtitle
                            }),
                            checkState.map(function(check) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                    htmlFor: check.key,
                                    style: {
                                        display: "block",
                                        cursor: "pointer",
                                        marginBottom: "24px"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                        alignItems: "center",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                style: {
                                                    flex: "none",
                                                    alignSelf: "flex-start",
                                                    paddingTop: "8px"
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                                                    id: check.key,
                                                    scale: "sm",
                                                    checked: check.value,
                                                    onChange: function() {
                                                        return handleSetAcknowledgeRisk(check.key);
                                                    }
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                ml: "8px",
                                                children: check.content
                                            })
                                        ]
                                    })
                                }, check.key);
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        id: "".concat(id, "-continue"),
                        width: "100%",
                        onClick: handleConfirm,
                        disabled: checkState.some(function(check) {
                            return !check.value;
                        }),
                        children: t("Continue")
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var components_DisclaimerModal = (DisclaimerModal);

;// CONCATENATED MODULE: ./src/views/LimitOrders/components/ClaimWarning.tsx







function ClaimWarning() {
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var ref = (0,_sliced_to_array/* default */.Z)((0,user_hooks/* useUserLimitOrderAcceptedWarning */.$c)(), 2), hasAcceptedRisk = ref[0], setHasAcceptedRisk = ref[1];
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,useModal/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)(components_DisclaimerModal, {
        id: "disclaimer-limit-order",
        header: t("I acknowledge that:"),
        checks: [
            {
                key: "price-checkbox",
                content: t("I understand that small orders are executed at higher execution price due to gas fees.")
            },
            {
                key: "taxtoken-checkbox",
                content: t("I understand that using taxed tokens on limit orders is highly discouraged and not recommended - Taxed tokens can be stuck in limit orders and lost forever because of impossibility to execute an order for such tokens")
            }, 
        ],
        onSuccess: function() {
            return setHasAcceptedRisk(true);
        }
    }), false, false), 2), onPresentRiskDisclaimer = ref1[0], onDismiss = ref1[1];
    (0,react.useEffect)(function() {
        if (!hasAcceptedRisk) {
            onPresentRiskDisclaimer();
        }
        return function() {
            onDismiss();
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        hasAcceptedRisk
    ]);
    return null;
}
/* harmony default export */ var components_ClaimWarning = (/*#__PURE__*/(0,react.memo)(ClaimWarning));

;// CONCATENATED MODULE: ./src/views/LimitOrders/styles.tsx

function styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  flex-direction: column;\n  justify-content: space-between;\n  padding: 1rem;\n"
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-shrink: 0;\n  height: fit-content;\n  padding: 0 24px;\n\n  ",
        " {\n    padding: 0 40px;\n  }\n\n  ",
        " {\n    ",
        ";\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 328px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


var Wrapper = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-8e2c23ef-0"
})(styles_templateObject());
var StyledSwapContainer = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-8e2c23ef-1"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.lg;
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.xxl;
}, function(param) {
    var $isChartExpanded = param.$isChartExpanded;
    return $isChartExpanded ? "padding: 0 120px" : "padding: 0 40px";
});
var StyledInputCurrencyWrapper = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
    componentId: "sc-8e2c23ef-2"
})(_templateObject2());

// EXTERNAL MODULE: ./packages/uikit/src/components/Button/IconButton.tsx
var IconButton = __webpack_require__(5527);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/ChartDisable.tsx
var ChartDisable = __webpack_require__(16883);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/Chart.tsx
var Chart = __webpack_require__(85462);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/History.tsx
var History = __webpack_require__(85714);
// EXTERNAL MODULE: ./src/components/App/Transactions/TransactionsModal.tsx + 1 modules
var TransactionsModal = __webpack_require__(86921);
;// CONCATENATED MODULE: ./src/views/LimitOrders/components/CurrencyInputHeader.tsx


function CurrencyInputHeader_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-direction: column;\n  align-items: center;\n  padding: 24px;\n  width: 100%;\n  border-bottom: 1px solid ",
        ";\n"
    ]);
    CurrencyInputHeader_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CurrencyInputHeader_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n"
    ]);
    CurrencyInputHeader_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}





var CurrencyInputContainer = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-fe365c31-0"
})(CurrencyInputHeader_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.cardBorder;
});
var ColoredIconButton = (0,styled_components_browser_esm/* default */.ZP)(IconButton/* default */.Z).withConfig({
    componentId: "sc-fe365c31-1"
})(CurrencyInputHeader_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.colors.textSubtle;
});
var CurrencyInputHeader = function(param) {
    var title = param.title, subtitle = param.subtitle, setIsChartDisplayed = param.setIsChartDisplayed, isChartDisplayed = param.isChartDisplayed;
    var toggleChartDisplayed = function() {
        setIsChartDisplayed(function(currentIsChartDisplayed) {
            return !currentIsChartDisplayed;
        });
    };
    var ref = (0,_sliced_to_array/* default */.Z)((0,useModal/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)(TransactionsModal/* default */.Z, {})), 1), onPresentTransactionsModal = ref[0];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CurrencyInputContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                width: "100%",
                alignItems: "center",
                justifyContent: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                        flex: "1",
                        children: setIsChartDisplayed && /*#__PURE__*/ (0,jsx_runtime.jsx)(ColoredIconButton, {
                            onClick: toggleChartDisplayed,
                            variant: "text",
                            scale: "sm",
                            children: isChartDisplayed ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ChartDisable/* default */.Z, {
                                color: "textSubtle"
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Chart/* default */.Z, {
                                width: "24px",
                                color: "textSubtle"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                        flex: "1",
                        justifyContent: "center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                            as: "h2",
                            children: title
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                        flex: "1",
                        justifyContent: "flex-end",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                            onClick: onPresentTransactionsModal,
                            variant: "text",
                            scale: "sm",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(History/* default */.Z, {
                                color: "textSubtle",
                                width: "24px"
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                alignItems: "center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    color: "textSubtle",
                    fontSize: "14px",
                    children: subtitle
                })
            })
        ]
    });
};
/* harmony default export */ var components_CurrencyInputHeader = (CurrencyInputHeader);

// EXTERNAL MODULE: ./packages/uikit/src/components/Input/Input.tsx
var Input = __webpack_require__(5324);
// EXTERNAL MODULE: ./packages/uikit/src/hooks/useTooltip/useTooltip.tsx + 1 modules
var useTooltip = __webpack_require__(36544);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/AutoRenew.tsx
var AutoRenew = __webpack_require__(19729);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/SyncAlt.tsx
var SyncAlt = __webpack_require__(29973);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/Help.tsx
var Help = __webpack_require__(62276);
;// CONCATENATED MODULE: ./src/views/LimitOrders/utils/getRatePercentageMessage.ts
var PercentageDirection;
(function(PercentageDirection) {
    PercentageDirection["ABOVE"] = "above";
    PercentageDirection["BELOW"] = "below";
    PercentageDirection["MARKET"] = "market";
})(PercentageDirection || (PercentageDirection = {}));
var getRatePercentageMessage = function(percentageRateDifference, t) {
    if (percentageRateDifference) {
        if (percentageRateDifference.equalTo(0)) {
            return [
                t("at market price"),
                PercentageDirection.MARKET
            ];
        }
        var percentageAsString = percentageRateDifference.toSignificant(6);
        var formattedPercentage = parseFloat(percentageAsString).toLocaleString(undefined, {
            minimumFractionDigits: 0,
            maximumFractionDigits: 2
        });
        if (percentageRateDifference.lessThan("0")) {
            return [
                t("%percentage%% below market", {
                    percentage: formattedPercentage
                }),
                PercentageDirection.BELOW
            ];
        }
        return [
            t("%percentage%% above market", {
                percentage: formattedPercentage
            }),
            PercentageDirection.ABOVE
        ];
    }
    return [
        null,
        null
    ];
};

;// CONCATENATED MODULE: ./src/views/LimitOrders/components/LimitOrderPrice.tsx



function LimitOrderPrice_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: right;\n"
    ]);
    LimitOrderPrice_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function LimitOrderPrice_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  cursor: pointer;\n"
    ]);
    LimitOrderPrice_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}








var inputRegex = RegExp("^\\d*(?:\\\\[.])?\\d*$") // match escaped "." characters via in a non-capturing group
;
var OrderPriceInput = (0,styled_components_browser_esm/* default */.ZP)(Input/* default */.Z).withConfig({
    componentId: "sc-70b87d59-0"
})(LimitOrderPrice_templateObject());
var LabelContainer = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-70b87d59-1"
})(LimitOrderPrice_templateObject1());
var _obj;
var DIRECTION_COLORS = (_obj = {}, (0,_define_property/* default */.Z)(_obj, PercentageDirection.ABOVE, "success"), (0,_define_property/* default */.Z)(_obj, PercentageDirection.BELOW, "failure"), (0,_define_property/* default */.Z)(_obj, PercentageDirection.MARKET, "textSubtle"), _obj);
var LimitOrderPrice = function(param) {
    var id = param.id, value = param.value, onUserInput = param.onUserInput, inputCurrency = param.inputCurrency, outputCurrency = param.outputCurrency, percentageRateDifference = param.percentageRateDifference, rateType = param.rateType, handleRateType = param.handleRateType, price = param.price, handleResetToMarketPrice = param.handleResetToMarketPrice, realExecutionPriceAsString = param.realExecutionPriceAsString, disabled = param.disabled;
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var hasCurrencyInfo = inputCurrency && outputCurrency;
    var label = rateType === types/* Rate.MUL */.j.MUL ? "".concat(outputCurrency === null || outputCurrency === void 0 ? void 0 : outputCurrency.symbol, " per ").concat(inputCurrency === null || inputCurrency === void 0 ? void 0 : inputCurrency.symbol) : "".concat(inputCurrency === null || inputCurrency === void 0 ? void 0 : inputCurrency.symbol, " per ").concat(outputCurrency === null || outputCurrency === void 0 ? void 0 : outputCurrency.symbol);
    var toggleRateType = function() {
        handleRateType(rateType, price);
    };
    var ref = (0,useTooltip/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                children: t("Takes into account the gas necessary to execute your order and guarantees that your desired rate is fulfilled.")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                children: t("It fluctuates according to gas prices.")
            }),
            (inputCurrency === null || inputCurrency === void 0 ? void 0 : inputCurrency.symbol) && (outputCurrency === null || outputCurrency === void 0 ? void 0 : outputCurrency.symbol) && realExecutionPriceAsString && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                children: realExecutionPriceAsString === "never executes" ? t("Assuming current gas price this order will never execute. Try increasing the amount of tokens to swap.") : t("Assuming current gas price it should execute when 1 %assetOneSymbol% = %price% %assetTwoSymbol%", {
                    assetOneSymbol: rateType === types/* Rate.MUL */.j.MUL ? inputCurrency === null || inputCurrency === void 0 ? void 0 : inputCurrency.symbol : outputCurrency === null || outputCurrency === void 0 ? void 0 : outputCurrency.symbol,
                    assetTwoSymbol: rateType === types/* Rate.MUL */.j.MUL ? outputCurrency === null || outputCurrency === void 0 ? void 0 : outputCurrency.symbol : inputCurrency === null || inputCurrency === void 0 ? void 0 : inputCurrency.symbol,
                    price: realExecutionPriceAsString
                })
            })
        ]
    }), {
        placement: "top"
    }), targetRef = ref.targetRef, tooltip = ref.tooltip, tooltipVisible = ref.tooltipVisible;
    var handleOnChange = function(event) {
        var nextUserInput = event.target.value.replace(/,/g, ".");
        if (nextUserInput === "" || inputRegex.test((0,utils/* escapeRegExp */.hr)(nextUserInput))) {
            onUserInput(nextUserInput);
        }
    };
    var ref1;
    var isAtMarketPrice = (ref1 = percentageRateDifference === null || percentageRateDifference === void 0 ? void 0 : percentageRateDifference.equalTo(0)) !== null && ref1 !== void 0 ? ref1 : true;
    var ref2 = (0,_sliced_to_array/* default */.Z)(getRatePercentageMessage(percentageRateDifference, t), 2), ratePercentageMessage = ref2[0], direction = ref2[1];
    var priceLabelColor = DIRECTION_COLORS[direction];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                justifyContent: "space-between",
                id: id,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                mr: "8px",
                                color: "secondary",
                                fontSize: "12px",
                                bold: true,
                                textTransform: "uppercase",
                                children: t("Price")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                onClick: handleResetToMarketPrice,
                                startIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(AutoRenew/* default */.Z, {
                                    color: isAtMarketPrice ? "textDisabled" : "primary"
                                }),
                                variant: "secondary",
                                scale: "xs",
                                disabled: isAtMarketPrice,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    fontSize: "12px",
                                    bold: true,
                                    color: isAtMarketPrice ? "textDisabled" : "primary",
                                    textTransform: "uppercase",
                                    children: t("Market")
                                })
                            })
                        ]
                    }),
                    ratePercentageMessage && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        color: priceLabelColor,
                        fontSize: "12px",
                        children: ratePercentageMessage
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderPriceInput, {
                value: value,
                disabled: disabled,
                onChange: handleOnChange,
                autoComplete: "off",
                autoCorrect: "off",
                pattern: "^[0-9]*[.,]?[0-9]*$",
                minLength: 1,
                maxLength: 79,
                spellCheck: "false",
                type: "text",
                inputMode: "decimal"
            }),
            hasCurrencyInfo && /*#__PURE__*/ (0,jsx_runtime.jsxs)(LabelContainer, {
                justifyContent: "flex-end",
                alignItems: "center",
                onClick: toggleRateType,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        small: true,
                        bold: true,
                        children: label
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SyncAlt/* default */.Z, {
                        color: "textSubtle",
                        width: "24px",
                        ml: "4px"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                justifySelf: "flex-end",
                mb: "8px",
                minHeight: "16px",
                children: realExecutionPriceAsString && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            small: true,
                            color: "textSubtle",
                            mr: "4px",
                            children: t("Real execution price: %price%", {
                                price: realExecutionPriceAsString
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            ref: targetRef,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Help/* default */.Z, {
                                    color: "textSubtle"
                                }),
                                tooltipVisible && tooltip
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var components_LimitOrderPrice = (LimitOrderPrice);

// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/ArrowDown.tsx
var ArrowDown = __webpack_require__(6372);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/ArrowUpDown.tsx
var ArrowUpDown = __webpack_require__(92863);
// EXTERNAL MODULE: ./src/components/Layout/Row.tsx
var Row = __webpack_require__(39475);
;// CONCATENATED MODULE: ./src/views/LimitOrders/components/SwitchTokensButton.tsx

function SwitchTokensButton_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  box-shadow: inset 0px -2px 0px rgba(0, 0, 0, 0.1);\n  .icon-up-down {\n    display: none;\n  }\n  &:hover {\n    background-color: ",
        ";\n    .icon-down {\n      display: none;\n      fill: white;\n    }\n    .icon-up-down {\n      display: block;\n      fill: white;\n    }\n  }\n"
    ]);
    SwitchTokensButton_templateObject = function _templateObject() {
        return data;
    };
    return data;
}






var StyledButton = (0,styled_components_browser_esm/* default */.ZP)(IconButton/* default */.Z).withConfig({
    componentId: "sc-6b179343-0"
})(SwitchTokensButton_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.primary;
});
var SwitchIconButton = function(param) {
    var handleSwitchTokens = param.handleSwitchTokens, color = param.color;
    var handleOnClick = (0,react.useCallback)(function() {
        return handleSwitchTokens === null || handleSwitchTokens === void 0 ? void 0 : handleSwitchTokens();
    }, [
        handleSwitchTokens
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Column/* AutoColumn */.Tz, {
        justify: "space-between",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* AutoRow */.BA, {
            justify: "center",
            style: {
                padding: "0 1rem"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledButton, {
                variant: "light",
                scale: "sm",
                onClick: handleOnClick,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowDown/* default */.Z, {
                        className: "icon-down",
                        color: color
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowUpDown/* default */.Z, {
                        className: "icon-up-down",
                        color: color
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var SwitchTokensButton = (SwitchIconButton);

// EXTERNAL MODULE: ./src/views/Page.tsx
var Page = __webpack_require__(49438);
// EXTERNAL MODULE: ./packages/uikit/src/components/Card/Card.tsx + 1 modules
var Card = __webpack_require__(38144);
// EXTERNAL MODULE: ./packages/uikit/src/components/ButtonMenu/ButtonMenu.tsx
var ButtonMenu = __webpack_require__(50156);
// EXTERNAL MODULE: ./packages/uikit/src/components/ButtonMenu/ButtonMenuItem.tsx
var ButtonMenuItem = __webpack_require__(39320);
;// CONCATENATED MODULE: ./src/views/LimitOrders/components/LimitOrderTable/OrderTab.tsx

function OrderTab_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  & > div {\n    width: 100%;\n    background-color: ",
        ";\n    border: 0;\n  }\n  & button {\n    border-bottom-left-radius: 0px;\n    border-bottom-right-radius: 0px;\n  }\n"
    ]);
    OrderTab_templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var OrderTab_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3054ce9a-0"
})(OrderTab_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.input;
});
var OrderTab = function(param) {
    var activeIndex = param.activeIndex, onItemClick = param.onItemClick;
    var theme = (0,useTheme/* default */.ZP)().theme;
    var t = (0,localization_src/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderTab_Wrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonMenu/* default */.Z, {
            activeIndex: activeIndex,
            onItemClick: onItemClick,
            children: [
                t("Open Orders"),
                t("Order History")
            ].map(function(content, idx) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonMenuItem/* default */.Z, {
                    style: {
                        color: idx === activeIndex ? theme.colors.text : theme.colors.textSubtle,
                        backgroundColor: idx === activeIndex ? theme.card.background : theme.colors.input
                    },
                    children: content
                }, content);
            })
        })
    });
};
/* harmony default export */ var LimitOrderTable_OrderTab = (OrderTab);

// EXTERNAL MODULE: ./packages/uikit/src/components/Table/Table.tsx
var Table = __webpack_require__(48993);
// EXTERNAL MODULE: ./packages/uikit/src/components/Table/Cell.tsx
var Cell = __webpack_require__(158);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/ChevronRight.tsx
var ChevronRight = __webpack_require__(94528);
;// CONCATENATED MODULE: ./src/views/LimitOrders/hooks/useFormattedOrderData.ts










var formatForDisplay = function(amount) {
    if (!amount) {
        return undefined;
    }
    return parseFloat(amount.toSignificant(18)).toLocaleString(undefined, {
        minimumFractionDigits: 0,
        maximumFractionDigits: 8
    });
};
// Transforms Gelato Order type into types ready to be displayed in UI
var useFormattedOrderData = function(order) {
    var chainId = (0,useActiveWeb3React/* default */.Z)().chainId;
    var gelatoLibrary = (0,useGelatoLimitOrdersLib/* default */.Z)();
    var inputToken = (0,Tokens/* useCurrency */.U8)(order.inputToken);
    var outputToken = (0,Tokens/* useCurrency */.U8)(order.outputToken);
    var isSubmissionPending = (0,transactions_hooks/* useIsTransactionPending */.ub)(order.createdTxHash);
    var _cancelledTxHash;
    var isCancellationPending = (0,transactions_hooks/* useIsTransactionPending */.ub)((_cancelledTxHash = order.cancelledTxHash) !== null && _cancelledTxHash !== void 0 ? _cancelledTxHash : undefined);
    var inputAmount = (0,react.useMemo)(function() {
        if (inputToken && order.inputAmount) {
            if ((0,_instanceof/* default */.Z)(inputToken, src/* Token */.WU)) {
                return new src/* TokenAmount */.dt(inputToken, order.inputAmount);
            }
            return src/* CurrencyAmount.ether */.ih.ether(order.inputAmount);
        }
        return undefined;
    }, [
        inputToken,
        order.inputAmount
    ]);
    var rawMinReturn = (0,react.useMemo)(function() {
        return order.adjustedMinReturn ? order.adjustedMinReturn : gelatoLibrary && chainId && order.minReturn ? gelatoLibrary.getAdjustedMinReturn(order.minReturn) : undefined;
    }, [
        chainId,
        gelatoLibrary,
        order.adjustedMinReturn,
        order.minReturn
    ]);
    var outputAmount = (0,react.useMemo)(function() {
        if (outputToken && rawMinReturn) {
            if ((0,_instanceof/* default */.Z)(outputToken, src/* Token */.WU)) {
                return new src/* TokenAmount */.dt(outputToken, rawMinReturn);
            }
            return src/* CurrencyAmount.ether */.ih.ether(rawMinReturn);
        }
        return undefined;
    }, [
        outputToken,
        rawMinReturn
    ]);
    var executionPrice = (0,react.useMemo)(function() {
        return utils_getPriceForOneToken(inputAmount, outputAmount);
    }, [
        inputAmount,
        outputAmount
    ]);
    return {
        inputToken: inputToken,
        outputToken: outputToken,
        inputAmount: formatForDisplay(inputAmount),
        outputAmount: formatForDisplay(outputAmount),
        executionPrice: formatForDisplay(executionPrice),
        invertedExecutionPrice: formatForDisplay(executionPrice === null || executionPrice === void 0 ? void 0 : executionPrice.invert()),
        isOpen: order.status === LimitOrderStatus.OPEN,
        isCancelled: order.status === LimitOrderStatus.CANCELLED,
        isExecuted: order.status === LimitOrderStatus.EXECUTED,
        isSubmissionPending: isSubmissionPending,
        isCancellationPending: isCancellationPending,
        bscScanUrls: {
            created: order.createdTxHash ? (0,utils/* getBscScanLink */.s6)(order.createdTxHash, "transaction") : null,
            executed: order.executedTxHash ? (0,utils/* getBscScanLink */.s6)(order.executedTxHash, "transaction") : null,
            cancelled: order.cancelledTxHash ? (0,utils/* getBscScanLink */.s6)(order.cancelledTxHash, "transaction") : null
        }
    };
};
/* harmony default export */ var hooks_useFormattedOrderData = (useFormattedOrderData);

// EXTERNAL MODULE: ./src/components/Logo/CurrencyLogo.tsx + 1 modules
var CurrencyLogo = __webpack_require__(292);
;// CONCATENATED MODULE: ./src/views/LimitOrders/components/LimitOrderTable/TextIcon.tsx


var TextIcon = function(param) {
    var icon = param.icon, text = param.text, _bold = param.bold, bold = _bold === void 0 ? false : _bold;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
        alignItems: "center",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                color: "text",
                mr: "8px",
                bold: bold,
                textTransform: "uppercase",
                children: text
            }),
            icon
        ]
    });
};
/* harmony default export */ var LimitOrderTable_TextIcon = (TextIcon);

;// CONCATENATED MODULE: ./src/views/LimitOrders/components/LimitOrderTable/CurrencyFormat.tsx



var CurrencyFormat = function(param) {
    var currency = param.currency, bold = param.bold;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LimitOrderTable_TextIcon, {
        bold: bold,
        text: currency === null || currency === void 0 ? void 0 : currency.symbol,
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(CurrencyLogo/* default */.Z, {
            currency: currency
        })
    });
};
/* harmony default export */ var LimitOrderTable_CurrencyFormat = (CurrencyFormat);

// EXTERNAL MODULE: ./packages/uikit/src/widgets/Modal/Modal.tsx
var Modal = __webpack_require__(90452);
// EXTERNAL MODULE: ./packages/uikit/src/components/Tag/Tag.tsx + 3 modules
var Tag = __webpack_require__(24930);
// EXTERNAL MODULE: ./packages/uikit/src/components/Spinner/Spinner.tsx + 2 modules
var Spinner = __webpack_require__(63603);
// EXTERNAL MODULE: ./src/components/TransactionConfirmationModal/index.tsx
var TransactionConfirmationModal = __webpack_require__(41228);
;// CONCATENATED MODULE: ./src/views/LimitOrders/components/LimitOrderTable/CellFormat.tsx


var CellFormat = function(param) {
    var firstRow = param.firstRow, secondRow = param.secondRow;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                mb: "4px",
                children: firstRow
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                children: secondRow
            })
        ]
    });
};
/* harmony default export */ var LimitOrderTable_CellFormat = (CellFormat);

// EXTERNAL MODULE: ./packages/uikit/src/components/Message/Message.tsx + 1 modules
var Message = __webpack_require__(67334);
;// CONCATENATED MODULE: ./src/views/LimitOrders/components/LimitOrderDisclaimer.tsx



var LimitOrderDisclaimer = function() {
    var t = (0,localization_src/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Message/* default */.Z, {
        variant: "warning",
        mt: "24px",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Message/* MessageText */.Y, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                    children: t("Real Execution Price:")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("ol", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            children: t("Your execution gas fees are paid for by the spread between your specified price and the real execution price.")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            children: t("Gas fees are volatile and thus the exact market price at which your order will execute is unpredictable.")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            children: t("It might take much longer than you expected to reach the price that fills your order + fees.")
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                    children: t('"Fee on Transfer" Tokens')
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("ol", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: t('"Fee on transfer" tokens should not be used with Limit Orders (use at your own risk)')
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var components_LimitOrderDisclaimer = (LimitOrderDisclaimer);

;// CONCATENATED MODULE: ./src/views/LimitOrders/components/LimitOrderTable/DetailLimitOrderModal.tsx

function DetailLimitOrderModal_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-radius: 16px;\n  padding: 16px;\n  margin-top: 24px;\n  border: 1px solid ",
        ";\n  background-color: ",
        ";\n"
    ]);
    DetailLimitOrderModal_templateObject = function _templateObject() {
        return data;
    };
    return data;
}












var InfoCardWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-bb0d7d27-0"
})(DetailLimitOrderModal_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.cardBorder;
}, function(param) {
    var theme = param.theme;
    return theme.colors.background;
});
var DetailLimitOrderModal = function(param) {
    var onDismiss = param.onDismiss, order = param.order, formattedOrder = param.formattedOrder;
    var ref, ref1, ref2, ref3, ref4, ref5;
    var chainId = (0,useActiveWeb3React/* default */.Z)().chainId;
    var theme = (0,useTheme/* default */.ZP)().theme;
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var handleLimitOrderCancellation = limitOrders_useGelatoLimitOrdersHandlers().handleLimitOrderCancellation;
    var ref6 = (0,react.useState)({
        attemptingTxn: false,
        cancellationErrorMessage: undefined,
        txHash: undefined
    }), ref7 = ref6[0], cancellationErrorMessage = ref7.cancellationErrorMessage, attemptingTxn = ref7.attemptingTxn, txHash = ref7.txHash, setCancellationState = ref6[1];
    var onCancelOrder = (0,react.useCallback)(function() {
        var ref, ref1;
        if (!handleLimitOrderCancellation) {
            return;
        }
        setCancellationState({
            attemptingTxn: true,
            cancellationErrorMessage: undefined,
            txHash: undefined
        });
        var orderDetails = ((ref = formattedOrder.inputToken) === null || ref === void 0 ? void 0 : ref.symbol) && ((ref1 = formattedOrder.outputToken) === null || ref1 === void 0 ? void 0 : ref1.symbol) && formattedOrder.inputAmount && formattedOrder.outputAmount ? {
            inputTokenSymbol: formattedOrder.inputToken.symbol,
            outputTokenSymbol: formattedOrder.outputToken.symbol,
            inputAmount: formattedOrder.inputAmount,
            outputAmount: formattedOrder.outputAmount
        } : undefined;
        handleLimitOrderCancellation(order, orderDetails).then(function(param) {
            var hash = param.hash;
            setCancellationState({
                attemptingTxn: false,
                cancellationErrorMessage: undefined,
                txHash: hash
            });
        }).catch(function(error) {
            setCancellationState({
                attemptingTxn: false,
                cancellationErrorMessage: error.message,
                txHash: undefined
            });
        });
    }, [
        handleLimitOrderCancellation,
        formattedOrder.inputAmount,
        formattedOrder.outputAmount,
        (ref = formattedOrder.inputToken) === null || ref === void 0 ? void 0 : ref.symbol,
        (ref1 = formattedOrder.outputToken) === null || ref1 === void 0 ? void 0 : ref1.symbol,
        order, 
    ]);
    var limitPriceExchangeRateText = "1 ".concat((ref2 = formattedOrder.inputToken) === null || ref2 === void 0 ? void 0 : ref2.symbol, " = ").concat(formattedOrder.executionPrice, " ").concat((ref3 = formattedOrder.outputToken) === null || ref3 === void 0 ? void 0 : ref3.symbol);
    var limitPriceExchangeRateTextReversed = "1 ".concat((ref4 = formattedOrder.outputToken) === null || ref4 === void 0 ? void 0 : ref4.symbol, " = ").concat(formattedOrder.invertedExecutionPrice, " ").concat((ref5 = formattedOrder.inputToken) === null || ref5 === void 0 ? void 0 : ref5.symbol);
    var isOpen = formattedOrder.isOpen, isExecuted = formattedOrder.isExecuted, isCancelled = formattedOrder.isCancelled, isSubmissionPending = formattedOrder.isSubmissionPending, isCancellationPending = formattedOrder.isCancellationPending, bscScanUrls = formattedOrder.bscScanUrls;
    var orderDetails = /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                width: "100%",
                justifyContent: "space-between",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LimitOrderTable_CellFormat, {
                        firstRow: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            children: formattedOrder.inputAmount
                        }),
                        secondRow: /*#__PURE__*/ (0,jsx_runtime.jsx)(LimitOrderTable_CurrencyFormat, {
                            currency: formattedOrder.inputToken
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronRight/* default */.Z, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LimitOrderTable_CellFormat, {
                        firstRow: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            children: formattedOrder.outputAmount
                        }),
                        secondRow: /*#__PURE__*/ (0,jsx_runtime.jsx)(LimitOrderTable_CurrencyFormat, {
                            currency: formattedOrder.outputToken
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LimitTradeInfoCard, {
                currentPriceExchangeRateText: "0.002474 BNB = 1 BUSD",
                currentPriceExchangeRateTextReversed: "404.11169 BUSD = 1 BNB",
                limitPriceExchangeRateText: limitPriceExchangeRateText,
                limitPriceExchangeRateTextReversed: limitPriceExchangeRateTextReversed,
                isOpen: isOpen,
                isExecuted: isExecuted,
                isCancelled: isCancelled,
                isSubmissionPending: isSubmissionPending,
                isCancellationPending: isCancellationPending
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_LimitOrderDisclaimer, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                flexDirection: "column",
                children: [
                    isOpen ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                variant: "primary",
                                mt: "16px",
                                as: "a",
                                external: true,
                                href: formattedOrder.bscScanUrls.created,
                                children: t("View on BscScan")
                            }),
                            !isSubmissionPending && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                variant: "danger",
                                mt: "16px",
                                onClick: onCancelOrder,
                                children: t("Cancel Order")
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        variant: "primary",
                        mt: "16px",
                        as: "a",
                        external: true,
                        href: formattedOrder.bscScanUrls.created,
                        children: t("View order creation on BSCScan")
                    }),
                    isCancelled && bscScanUrls.cancelled && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        variant: "primary",
                        mt: "16px",
                        as: "a",
                        external: true,
                        href: bscScanUrls.cancelled,
                        children: t("View order cancellation on BSCScan")
                    }),
                    isExecuted && bscScanUrls.executed && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        variant: "primary",
                        mt: "16px",
                        as: "a",
                        external: true,
                        href: bscScanUrls.executed,
                        children: t("View order execution on BSCScan")
                    })
                ]
            })
        ]
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
        title: t("Open Order Details"),
        headerBackground: theme.colors.gradients.cardHeader,
        style: {
            width: "436px"
        },
        onDismiss: onDismiss,
        children: attemptingTxn ? /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingContent, {}) : txHash ? /*#__PURE__*/ (0,jsx_runtime.jsx)(TransactionConfirmationModal/* TransactionSubmittedContent */.rD, {
            chainId: chainId,
            hash: txHash,
            onDismiss: onDismiss
        }) : cancellationErrorMessage ? /*#__PURE__*/ (0,jsx_runtime.jsx)(TransactionConfirmationModal/* TransactionErrorContent */.ht, {
            onDismiss: onDismiss,
            message: cancellationErrorMessage
        }) : orderDetails
    });
};
var LimitTradeInfoCard = /*#__PURE__*/ (0,react.memo)(function(param) {
    var limitPriceExchangeRateText = param.limitPriceExchangeRateText, limitPriceExchangeRateTextReversed = param.limitPriceExchangeRateTextReversed, isOpen = param.isOpen, isExecuted = param.isExecuted, isCancelled = param.isCancelled, isSubmissionPending = param.isSubmissionPending, isCancellationPending = param.isCancellationPending;
    var t = (0,localization_src/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoCardWrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
            mb: "4px",
            children: [
                isOpen && isSubmissionPending && /*#__PURE__*/ (0,jsx_runtime.jsx)(Tag/* default */.Z, {
                    outline: true,
                    scale: "sm",
                    p: "8px",
                    mb: "16px",
                    variant: "warning",
                    children: t("Pending")
                }),
                isExecuted && /*#__PURE__*/ (0,jsx_runtime.jsx)(Tag/* default */.Z, {
                    outline: true,
                    scale: "sm",
                    p: "8px",
                    mb: "16px",
                    variant: "success",
                    children: t("Filled")
                }),
                isCancellationPending && /*#__PURE__*/ (0,jsx_runtime.jsx)(Tag/* default */.Z, {
                    outline: true,
                    scale: "sm",
                    p: "8px",
                    mb: "16px",
                    variant: "warning",
                    children: t("Cancelling")
                }),
                isCancelled && !isCancellationPending && /*#__PURE__*/ (0,jsx_runtime.jsx)(Tag/* default */.Z, {
                    outline: true,
                    scale: "sm",
                    p: "8px",
                    mb: "16px",
                    variant: "failure",
                    children: t("Cancelled")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    fontSize: "14px",
                    color: "textSubtle",
                    children: t("Limit Price")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                    flexDirection: "column",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            fontSize: "14px",
                            children: limitPriceExchangeRateText
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            fontSize: "14px",
                            children: limitPriceExchangeRateTextReversed
                        })
                    ]
                })
            ]
        })
    });
});
var LoadingContent = /*#__PURE__*/ (0,react.memo)(function() {
    var t = (0,localization_src/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                flexDirection: "column",
                flexGrow: "wrap",
                flexBasis: "267px",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        fontSize: "20px",
                        small: true,
                        color: "secondary",
                        children: t("Confirm")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        small: true,
                        color: "textSubtle",
                        mt: "8px",
                        children: t("Please confirm the transaction in your wallet")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Spinner/* default */.Z, {
                    size: 70
                })
            })
        ]
    });
});

;// CONCATENATED MODULE: ./src/views/LimitOrders/components/LimitOrderTable/OrderStatus.tsx




var StatusElementType;
(function(StatusElementType) {
    StatusElementType["TAG"] = "Tag";
    StatusElementType["TEXT"] = "Text";
})(StatusElementType || (StatusElementType = {}));
var StatusElement = function(param) {
    var element = param.element, text = param.text, color = param.color;
    if (element === StatusElementType.TAG) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Tag/* default */.Z, {
            outline: true,
            scale: "sm",
            variant: color,
            ml: "auto",
            children: text
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
        color: color,
        children: text
    });
};
var OrderStatus = function(param) {
    var formattedOrder = param.formattedOrder, _showOpenTag = param.showOpenTag, showOpenTag = _showOpenTag === void 0 ? false : _showOpenTag, _element = param.element, element = _element === void 0 ? StatusElementType.TAG : _element;
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var isOpen = formattedOrder.isOpen, isSubmissionPending = formattedOrder.isSubmissionPending, isCancelled = formattedOrder.isCancelled, isCancellationPending = formattedOrder.isCancellationPending, isExecuted = formattedOrder.isExecuted;
    if (isOpen && !isSubmissionPending && showOpenTag) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(StatusElement, {
            element: element,
            text: t("Open"),
            color: "success"
        });
    }
    if (isOpen && isSubmissionPending) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(StatusElement, {
            element: element,
            text: t("Pending"),
            color: "warning"
        });
    }
    if (isCancelled && !isCancellationPending) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(StatusElement, {
            element: element,
            text: t("Cancelled"),
            color: "failure"
        });
    }
    if (isCancellationPending) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(StatusElement, {
            element: element,
            text: t("Cancelling"),
            color: "warning"
        });
    }
    if (isExecuted) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(StatusElement, {
            element: element,
            text: t("Filled"),
            color: "success"
        });
    }
    return null;
};
/* harmony default export */ var LimitOrderTable_OrderStatus = (OrderStatus);

;// CONCATENATED MODULE: ./src/views/LimitOrders/components/LimitOrderTable/CompactRow.tsx








var CompactRow = function(param) {
    var order = param.order;
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var formattedOrder = hooks_useFormattedOrderData(order);
    var inputToken = formattedOrder.inputToken, outputToken = formattedOrder.outputToken, inputAmount = formattedOrder.inputAmount, outputAmount = formattedOrder.outputAmount, executionPrice = formattedOrder.executionPrice;
    var ref = (0,_sliced_to_array/* default */.Z)((0,useModal/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)(DetailLimitOrderModal, {
        order: order,
        formattedOrder: formattedOrder
    })), 1), openDetailLimitOrderModal = ref[0];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
        width: "100%",
        justifyContent: "center",
        alignItems: "center",
        onClick: openDetailLimitOrderModal,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
            width: "100%",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                    mb: "16px",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(LimitOrderTable_CurrencyFormat, {
                            bold: true,
                            currency: inputToken
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronRight/* default */.Z, {
                            color: "textSubtle"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(LimitOrderTable_CurrencyFormat, {
                            bold: true,
                            currency: outputToken
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(LimitOrderTable_OrderStatus, {
                            formattedOrder: formattedOrder
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                    justifyContent: "space-between",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            fontSize: "12px",
                            bold: true,
                            color: "textSubtle",
                            textTransform: "uppercase",
                            children: t("From")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            small: true,
                            textTransform: "uppercase",
                            children: "".concat(inputAmount, " ").concat(inputToken === null || inputToken === void 0 ? void 0 : inputToken.symbol)
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                    justifyContent: "space-between",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            fontSize: "12px",
                            bold: true,
                            color: "textSubtle",
                            textTransform: "uppercase",
                            children: t("To")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            small: true,
                            textTransform: "uppercase",
                            children: "".concat(outputAmount, " ").concat(outputToken === null || outputToken === void 0 ? void 0 : outputToken.symbol)
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                    justifyContent: "space-between",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            fontSize: "12px",
                            bold: true,
                            color: "textSubtle",
                            textTransform: "uppercase",
                            children: t("Price")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            small: true,
                            children: "".concat(executionPrice, " ").concat(outputToken === null || outputToken === void 0 ? void 0 : outputToken.symbol, " per ").concat(inputToken === null || inputToken === void 0 ? void 0 : inputToken.symbol)
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var LimitOrderTable_CompactRow = (CompactRow);

;// CONCATENATED MODULE: ./src/views/LimitOrders/components/LimitOrderTable/CompactLimitOrderTable.tsx

function CompactLimitOrderTable_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  cursor: pointer;\n\n  &:hover {\n    background: ",
        ";\n  }\n"
    ]);
    CompactLimitOrderTable_templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var RowStyle = styled_components_browser_esm/* default.tr.withConfig */.ZP.tr.withConfig({
    componentId: "sc-a6176c36-0"
})(CompactLimitOrderTable_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.backgroundDisabled;
});
var CompactLimitOrderTable = function(param) {
    var orders = param.orders;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Table/* default */.Z, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("tbody", {
            children: orders.map(function(order) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(RowStyle, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Cell.Td, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LimitOrderTable_CompactRow, {
                            order: order
                        })
                    })
                }, order.id);
            })
        })
    });
};
/* harmony default export */ var LimitOrderTable_CompactLimitOrderTable = (/*#__PURE__*/(0,react.memo)(CompactLimitOrderTable));

// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/MoreHorizontal.tsx
var MoreHorizontal = __webpack_require__(37320);
;// CONCATENATED MODULE: ./src/views/LimitOrders/components/LimitOrderTable/FullRow.tsx










var FullRow = function(param) {
    var order = param.order;
    var formattedOrder = hooks_useFormattedOrderData(order);
    var inputToken = formattedOrder.inputToken, outputToken = formattedOrder.outputToken, inputAmount = formattedOrder.inputAmount, outputAmount = formattedOrder.outputAmount, executionPrice = formattedOrder.executionPrice;
    var ref = (0,_sliced_to_array/* default */.Z)((0,useModal/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)(DetailLimitOrderModal, {
        order: order,
        formattedOrder: formattedOrder
    })), 1), openDetailLimitOrderModal = ref[0];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Cell.Td, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LimitOrderTable_CellFormat, {
                    firstRow: inputAmount,
                    secondRow: /*#__PURE__*/ (0,jsx_runtime.jsx)(LimitOrderTable_CurrencyFormat, {
                        bold: true,
                        currency: inputToken
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Cell.Td, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LimitOrderTable_CellFormat, {
                    firstRow: outputAmount,
                    secondRow: /*#__PURE__*/ (0,jsx_runtime.jsx)(LimitOrderTable_CurrencyFormat, {
                        bold: true,
                        currency: outputToken
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Cell.Td, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LimitOrderTable_CellFormat, {
                    firstRow: executionPrice,
                    secondRow: /*#__PURE__*/ (0,jsx_runtime.jsx)(LimitOrderTable_TextIcon, {
                        text: "".concat(outputToken === null || outputToken === void 0 ? void 0 : outputToken.symbol, "/").concat(inputToken === null || inputToken === void 0 ? void 0 : inputToken.symbol),
                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(SyncAlt/* default */.Z, {})
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Cell.Td, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LimitOrderTable_OrderStatus, {
                    formattedOrder: formattedOrder,
                    showOpenTag: true,
                    element: StatusElementType.TEXT
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Cell.Td, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                    variant: "text",
                    onClick: openDetailLimitOrderModal,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MoreHorizontal/* default */.Z, {})
                })
            })
        ]
    });
};
/* harmony default export */ var LimitOrderTable_FullRow = (FullRow);

;// CONCATENATED MODULE: ./src/views/LimitOrders/components/LimitOrderTable/SpaciousLimitOrderTable.tsx





var SpaciousLimitOrderTable = function(param) {
    var orders = param.orders;
    var t = (0,localization_src/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Table/* default */.Z, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("thead", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Cell.Th, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    fontSize: "12px",
                                    bold: true,
                                    textTransform: "uppercase",
                                    color: "textSubtle",
                                    textAlign: "left",
                                    children: t("From")
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Cell.Th, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    fontSize: "12px",
                                    bold: true,
                                    textTransform: "uppercase",
                                    color: "textSubtle",
                                    textAlign: "left",
                                    children: t("To")
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Cell.Th, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    fontSize: "12px",
                                    bold: true,
                                    textTransform: "uppercase",
                                    color: "textSubtle",
                                    textAlign: "left",
                                    children: t("Limit Price")
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Cell.Th, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    fontSize: "12px",
                                    bold: true,
                                    textTransform: "uppercase",
                                    color: "textSubtle",
                                    textAlign: "left",
                                    children: t("Status")
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Cell.Th, {})
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("tbody", {
                    children: orders.map(function(order) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(LimitOrderTable_FullRow, {
                            order: order
                        }, order.id);
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var LimitOrderTable_SpaciousLimitOrderTable = (/*#__PURE__*/(0,react.memo)(SpaciousLimitOrderTable));

// EXTERNAL MODULE: ./packages/uikit/src/components/Box/Grid.tsx
var Grid = __webpack_require__(26170);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/ArrowBack.tsx
var ArrowBack = __webpack_require__(69508);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/ArrowForward.tsx
var ArrowForward = __webpack_require__(16863);
// EXTERNAL MODULE: ./src/components/SubgraphHealthIndicator/index.tsx + 1 modules
var SubgraphHealthIndicator = __webpack_require__(118);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/BunnyPlaceholder.tsx
var BunnyPlaceholder = __webpack_require__(22661);
;// CONCATENATED MODULE: ./src/views/LimitOrders/components/LimitOrderTable/NoOrdersMessage.tsx





var NoOrdersMessage = function(param) {
    var orderCategory = param.orderCategory;
    var t = (0,localization_src/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
        p: "24px",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BunnyPlaceholder/* default */.Z, {
                width: 64
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                color: "textDisabled",
                children: orderCategory === ORDER_CATEGORY.Open ? t("No Open Orders") : t("No Order History")
            })
        ]
    });
};
/* harmony default export */ var LimitOrderTable_NoOrdersMessage = (NoOrdersMessage);

// EXTERNAL MODULE: ./packages/uikit/src/components/Skeleton/Skeleton.tsx + 1 modules
var Skeleton = __webpack_require__(84091);
;// CONCATENATED MODULE: ./src/views/LimitOrders/components/LimitOrderTable/LoadingTable.tsx



var LoadingTable = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Table/* default */.Z, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("tbody", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Cell.Td, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {})
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Cell.Td, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {})
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Cell.Td, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {})
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Cell.Td, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {})
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Cell.Td, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {})
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Cell.Td, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {})
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Cell.Td, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {})
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Cell.Td, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {})
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Cell.Td, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {})
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var LimitOrderTable_LoadingTable = (/*#__PURE__*/(0,react.memo)(LoadingTable));

;// CONCATENATED MODULE: ./src/views/LimitOrders/components/LimitOrderTable/TableNavigation.tsx

function TableNavigation_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  padding: 0 20px;\n  :hover {\n    cursor: pointer;\n  }\n"
    ]);
    TableNavigation_templateObject = function _templateObject() {
        return data;
    };
    return data;
}








var Arrow = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d6270113-0"
})(TableNavigation_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.primary;
});
var ORDERS_PER_PAGE = 5;
var TableNavigation = function(param) {
    var data = param.data, orderCategory = param.orderCategory, _itemsPerPage = param.itemsPerPage, itemsPerPage = _itemsPerPage === void 0 ? ORDERS_PER_PAGE : _itemsPerPage, children = param.children;
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var ref = (0,react.useState)(1), currentPage = ref[0], setPage = ref[1];
    var total = Array.isArray(data) ? data.length : 0;
    var maxPage = (0,react.useMemo)(function() {
        if (total) {
            return Math.ceil(total / itemsPerPage);
        }
        return 1;
    }, [
        total,
        itemsPerPage
    ]);
    var onPageNext = (0,react.useCallback)(function() {
        setPage(function(page) {
            return page === maxPage ? page : page + 1;
        });
    }, [
        maxPage
    ]);
    var onPagePrev = (0,react.useCallback)(function() {
        setPage(function(page) {
            return page === 1 ? page : page - 1;
        });
    }, []);
    var from = (0,react.useMemo)(function() {
        return itemsPerPage * (currentPage - 1);
    }, [
        currentPage,
        itemsPerPage
    ]);
    var to = (0,react.useMemo)(function() {
        return itemsPerPage * currentPage;
    }, [
        currentPage,
        itemsPerPage
    ]);
    var paginatedData = (0,react.useMemo)(function() {
        return Array.isArray(data) ? data.slice(from, to) : [];
    }, [
        data,
        from,
        to
    ]);
    (0,react.useEffect)(function() {
        setPage(1);
    }, [
        orderCategory
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            children({
                paginatedData: paginatedData
            }),
            !data && /*#__PURE__*/ (0,jsx_runtime.jsx)(LimitOrderTable_LoadingTable, {}),
            data && !total && /*#__PURE__*/ (0,jsx_runtime.jsx)(LimitOrderTable_NoOrdersMessage, {
                orderCategory: orderCategory
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                gridGap: "16px",
                gridTemplateColumns: [
                    "1fr",
                    null,
                    null,
                    null,
                    "1fr 2fr 1fr"
                ],
                mt: "16px",
                mb: "16px",
                px: "16px",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        width: "100%",
                        justifyContent: "center",
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Arrow, {
                                onClick: onPagePrev,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowBack/* default */.Z, {
                                    color: currentPage === 1 ? "textDisabled" : "primary"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                children: t("Page %page% of %maxPage%", {
                                    page: currentPage,
                                    maxPage: maxPage
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Arrow, {
                                onClick: onPageNext,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowForward/* default */.Z, {
                                    color: currentPage === maxPage ? "textDisabled" : "primary"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                        width: "100%",
                        justifyContent: [
                            "center",
                            null,
                            null,
                            null,
                            "flex-end"
                        ],
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SubgraphHealthIndicator["default"], {
                            subgraphName: "gelatodigital/limit-orders-bsc",
                            inline: true
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var LimitOrderTable_TableNavigation = (/*#__PURE__*/(0,react.memo)(TableNavigation));

;// CONCATENATED MODULE: ./src/views/LimitOrders/components/LimitOrderTable/index.tsx









var OrderTable = /*#__PURE__*/ (0,react.memo)(function(param) {
    var orderCategory = param.orderCategory, isCompact = param.isCompact;
    var orders = useGelatoLimitOrdersHistory(orderCategory);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LimitOrderTable_TableNavigation, {
        data: orders,
        orderCategory: orderCategory,
        children: function(param) {
            var paginatedData = param.paginatedData;
            return isCompact ? /*#__PURE__*/ (0,jsx_runtime.jsx)(LimitOrderTable_CompactLimitOrderTable, {
                orders: paginatedData
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(LimitOrderTable_SpaciousLimitOrderTable, {
                orders: paginatedData
            });
        }
    });
});
var LimitOrderTable = function(param) {
    var isCompact = param.isCompact;
    var ref = (0,react.useState)(ORDER_CATEGORY.Open), activeTab = ref[0], setIndex = ref[1];
    var handleClick = (0,react.useCallback)(function(tabType) {
        return setIndex(tabType);
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
        flex: "1",
        justifyContent: "center",
        mb: "24px",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default */.Z, {
            style: {
                width: "100%",
                height: "max-content"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(LimitOrderTable_OrderTab, {
                    onItemClick: handleClick,
                    activeIndex: activeTab
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderTable, {
                    orderCategory: activeTab,
                    isCompact: isCompact
                })
            ]
        })
    });
};
/* harmony default export */ var components_LimitOrderTable = (/*#__PURE__*/(0,react.memo)(LimitOrderTable));

// EXTERNAL MODULE: ./src/components/Logo/index.ts + 2 modules
var Logo = __webpack_require__(74314);
;// CONCATENATED MODULE: ./src/views/LimitOrders/components/ConfirmLimitOrderModal.tsx

function ConfirmLimitOrderModal_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-radius: 16px;\n  padding: 16px;\n  margin-top: 24px;\n  border: 1px solid ",
        ";\n  background-color: ",
        ";\n"
    ]);
    ConfirmLimitOrderModal_templateObject = function _templateObject() {
        return data;
    };
    return data;
}











var ConfirmLimitOrderModal_InfoCardWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d47655c9-0"
})(ConfirmLimitOrderModal_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.cardBorder;
}, function(param) {
    var theme = param.theme;
    return theme.colors.background;
});
var ConfirmLimitOrderModal = function(param) {
    var onDismiss = param.onDismiss, currencies = param.currencies, formattedAmounts = param.formattedAmounts, currentMarketRate = param.currentMarketRate, currentMarketRateInverted = param.currentMarketRateInverted, limitPrice = param.limitPrice, limitPriceInverted = param.limitPriceInverted, percentageRateDifference = param.percentageRateDifference, onConfirm = param.onConfirm, attemptingTxn = param.attemptingTxn, txHash = param.txHash, customOnDismiss = param.customOnDismiss, swapErrorMessage = param.swapErrorMessage;
    var chainId = (0,useActiveWeb3React/* default */.Z)().chainId;
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var theme = (0,useTheme/* default */.ZP)().theme;
    var wrappedOutput = (0,wrappedCurrency/* wrappedCurrency */.pu)(currencies.output, chainId);
    var handleDismiss = function() {
        if (customOnDismiss) {
            customOnDismiss();
        }
        onDismiss();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* default */.Z, {
        title: t("Confirm Limit Order"),
        headerBackground: theme.colors.gradients.cardHeader,
        onDismiss: handleDismiss,
        style: {
            width: "436px"
        },
        children: [
            attemptingTxn ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ConfirmLimitOrderModal_LoadingContent, {}) : txHash ? /*#__PURE__*/ (0,jsx_runtime.jsx)(TransactionConfirmationModal/* TransactionSubmittedContent */.rD, {
                chainId: chainId,
                hash: txHash,
                currencyToAdd: wrappedOutput,
                onDismiss: handleDismiss
            }) : swapErrorMessage ? /*#__PURE__*/ (0,jsx_runtime.jsx)(TransactionConfirmationModal/* TransactionErrorContent */.ht, {
                onDismiss: handleDismiss,
                message: swapErrorMessage
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderContent, {
                currencies: currencies,
                formattedAmounts: formattedAmounts,
                currentMarketRate: currentMarketRate,
                currentMarketRateInverted: currentMarketRateInverted,
                limitPrice: limitPrice,
                limitPriceInverted: limitPriceInverted,
                percentageRateDifference: percentageRateDifference
            }),
            !txHash && !swapErrorMessage && /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                justifyContent: "center",
                mt: "24px",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    scale: "md",
                    variant: "primary",
                    onClick: onConfirm,
                    width: "100%",
                    disabled: attemptingTxn,
                    children: attemptingTxn ? t("Confirming...") : t("Confirm")
                })
            })
        ]
    });
};
var OrderContent = function(param) {
    var currencies = param.currencies, formattedAmounts = param.formattedAmounts, currentMarketRate = param.currentMarketRate, currentMarketRateInverted = param.currentMarketRateInverted, limitPrice = param.limitPrice, limitPriceInverted = param.limitPriceInverted, percentageRateDifference = param.percentageRateDifference;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var currentPriceExchangeRateText = "1 ".concat((ref = currencies.input) === null || ref === void 0 ? void 0 : ref.symbol, " = ").concat(currentMarketRate, " ").concat((ref1 = currencies.output) === null || ref1 === void 0 ? void 0 : ref1.symbol);
    var currentPriceExchangeRateTextReversed = "1 ".concat((ref2 = currencies.output) === null || ref2 === void 0 ? void 0 : ref2.symbol, " = ").concat(currentMarketRateInverted, " ").concat((ref3 = currencies.input) === null || ref3 === void 0 ? void 0 : ref3.symbol);
    var limitPriceExchangeRateText = "1 ".concat((ref4 = currencies.input) === null || ref4 === void 0 ? void 0 : ref4.symbol, " = ").concat(limitPrice, " ").concat((ref5 = currencies.output) === null || ref5 === void 0 ? void 0 : ref5.symbol);
    var limitPriceExchangeRateTextReversed = "1 ".concat((ref6 = currencies.output) === null || ref6 === void 0 ? void 0 : ref6.symbol, " = ").concat(limitPriceInverted, " ").concat((ref7 = currencies.input) === null || ref7 === void 0 ? void 0 : ref7.symbol);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                flexDirection: "column",
                width: "100%",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        alignItems: "center",
                        justifyContent: "space-between",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                fontSize: "24px",
                                color: "text",
                                children: formattedAmounts.input
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                alignItems: "center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        textTransform: "uppercase",
                                        color: "text",
                                        mr: "8px",
                                        children: (ref8 = currencies.input) === null || ref8 === void 0 ? void 0 : ref8.symbol
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Logo/* CurrencyLogo */.Xw, {
                                        currency: currencies.input
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                        justifyContent: "center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowDown/* default */.Z, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        alignItems: "center",
                        justifyContent: "space-between",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                fontSize: "24px",
                                color: "text",
                                children: formattedAmounts.output
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                alignItems: "center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        textTransform: "uppercase",
                                        color: "text",
                                        mr: "8px",
                                        children: (ref9 = currencies.output) === null || ref9 === void 0 ? void 0 : ref9.symbol
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Logo/* CurrencyLogo */.Xw, {
                                        currency: currencies.output
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ConfirmLimitOrderModal_LimitTradeInfoCard, {
                currentPriceExchangeRateText: currentPriceExchangeRateText,
                currentPriceExchangeRateTextReversed: currentPriceExchangeRateTextReversed,
                limitPriceExchangeRateText: limitPriceExchangeRateText,
                limitPriceExchangeRateTextReversed: limitPriceExchangeRateTextReversed
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Message/* default */.Z, {
                variant: "success",
                mt: "24px",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Message/* MessageText */.Y, {
                    children: t("Limit price is %percentage%% above the current market rate. The order will be executed when the market price reaches high enough above your limit price (to also pay for limit order execution gas fees).", {
                        percentage: percentageRateDifference
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_LimitOrderDisclaimer, {})
        ]
    });
};
var ConfirmLimitOrderModal_LimitTradeInfoCard = /*#__PURE__*/ (0,react.memo)(function(param) {
    var currentPriceExchangeRateText = param.currentPriceExchangeRateText, currentPriceExchangeRateTextReversed = param.currentPriceExchangeRateTextReversed, limitPriceExchangeRateText = param.limitPriceExchangeRateText, limitPriceExchangeRateTextReversed = param.limitPriceExchangeRateTextReversed;
    var t = (0,localization_src/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ConfirmLimitOrderModal_InfoCardWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                justifyContent: "space-between",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        fontSize: "14px",
                        color: "textSubtle",
                        children: t("Current Market Price")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        flexDirection: "column",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                color: "text",
                                fontSize: "14px",
                                bold: true,
                                children: currentPriceExchangeRateText
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                color: "text",
                                fontSize: "14px",
                                children: currentPriceExchangeRateTextReversed
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                justifyContent: "space-between",
                mt: "16px",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        fontSize: "14px",
                        color: "textSubtle",
                        children: t("Limit Price")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        flexDirection: "column",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                color: "#129E7D",
                                fontSize: "14px",
                                bold: true,
                                children: limitPriceExchangeRateText
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                color: "#129E7D",
                                fontSize: "14px",
                                children: limitPriceExchangeRateTextReversed
                            })
                        ]
                    })
                ]
            })
        ]
    });
});
var ConfirmLimitOrderModal_LoadingContent = /*#__PURE__*/ (0,react.memo)(function() {
    var t = (0,localization_src/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                flexDirection: "column",
                flexGrow: "wrap",
                flexBasis: "267px",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        fontSize: "20px",
                        small: true,
                        color: "secondary",
                        children: t("Confirm")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        small: true,
                        color: "textSubtle",
                        mt: "8px",
                        children: t("Please confirm the transaction in your wallet")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Spinner/* default */.Z, {
                    size: 70
                })
            })
        ]
    });
});

;// CONCATENATED MODULE: ./src/views/LimitOrders/utils/getRatePercentageDifference.ts

var getRatePercentageDifference = function(currentMarketRate, price) {
    if (currentMarketRate && price) {
        var percentageAsFraction = price.subtract(currentMarketRate).divide(currentMarketRate);
        return new src/* Percent */.gG(percentageAsFraction.numerator, percentageAsFraction.denominator);
    }
    return undefined;
};
/* harmony default export */ var utils_getRatePercentageDifference = (getRatePercentageDifference);

// EXTERNAL MODULE: ./src/components/ImportTokenWarningModal.tsx
var ImportTokenWarningModal = __webpack_require__(19131);
;// CONCATENATED MODULE: ./src/views/LimitOrders/index.tsx






































var LimitOrders = function() {
    var ref, ref1, ref2, ref3, ref4;
    // Helpers
    var account = (0,core_esm/* useWeb3React */.Ge)().account;
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var router = (0,next_router.useRouter)();
    var ref5 = (0,useMatchBreakpointsContext/* default */.Z)(), isMobile = ref5.isMobile, isTablet = ref5.isTablet;
    var theme = (0,useTheme/* default */.ZP)().theme;
    var ref6 = (0,_sliced_to_array/* default */.Z)((0,user_hooks/* useExchangeChartManager */.vD)(isMobile), 2), userChartPreference = ref6[0], setUserChartPreference = ref6[1];
    var ref7 = (0,react.useState)(false), isChartExpanded = ref7[0], setIsChartExpanded = ref7[1];
    var ref8 = (0,react.useState)(userChartPreference), isChartDisplayed = ref8[0], setIsChartDisplayed = ref8[1];
    (0,react.useEffect)(function() {
        setUserChartPreference(isChartDisplayed);
    }, [
        isChartDisplayed,
        setUserChartPreference
    ]);
    var loadedUrlParams = useDefaultsFromURLSearch();
    // token warning stuff
    var ref9 = [
        (0,Tokens/* useCurrency */.U8)(loadedUrlParams === null || loadedUrlParams === void 0 ? void 0 : loadedUrlParams.inputCurrencyId),
        (0,Tokens/* useCurrency */.U8)(loadedUrlParams === null || loadedUrlParams === void 0 ? void 0 : loadedUrlParams.outputCurrencyId), 
    ], loadedInputCurrency = ref9[0], loadedOutputCurrency = ref9[1];
    var ref10;
    var urlLoadedTokens = (0,react.useMemo)(function() {
        var ref;
        return (ref10 = (ref = [
            loadedInputCurrency,
            loadedOutputCurrency
        ]) === null || ref === void 0 ? void 0 : ref.filter(function(c) {
            return (0,_instanceof/* default */.Z)(c, src/* Token */.WU);
        })) !== null && ref10 !== void 0 ? ref10 : [];
    }, [
        loadedInputCurrency,
        loadedOutputCurrency
    ]);
    // dismiss warning if all imported tokens are in active lists
    var defaultTokens = (0,Tokens/* useAllTokens */.e_)();
    var importTokensNotInDefault = (0,react.useMemo)(function() {
        return urlLoadedTokens && urlLoadedTokens.filter(function(token) {
            return !(token.address in defaultTokens);
        });
    }, [
        defaultTokens,
        urlLoadedTokens
    ]);
    var ref11 = (0,_sliced_to_array/* default */.Z)((0,useModal/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)(ImportTokenWarningModal/* default */.Z, {
        tokens: importTokensNotInDefault,
        onCancel: function() {
            return router.push("/limit-orders");
        }
    }), false, false, "limitOrderTokenWarningModal"), 1), onPresentImportTokenWarningModal = ref11[0];
    (0,react.useEffect)(function() {
        if (importTokensNotInDefault.length > 0) {
            onPresentImportTokenWarningModal();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        importTokensNotInDefault.length
    ]);
    // TODO: fiat values
    var ref12 = limitOrders_useGelatoLimitOrders(), _handlers = ref12.handlers, handleInput = _handlers.handleInput, handleCurrencySelection = _handlers.handleCurrencySelection, handleSwitchTokens = _handlers.handleSwitchTokens, handleLimitOrderSubmission = _handlers.handleLimitOrderSubmission, handleRateType = _handlers.handleRateType, _derivedOrderInfo = ref12.derivedOrderInfo, currencies = _derivedOrderInfo.currencies, currencyBalances = _derivedOrderInfo.currencyBalances, parsedAmounts = _derivedOrderInfo.parsedAmounts, formattedAmounts = _derivedOrderInfo.formattedAmounts, rawAmounts = _derivedOrderInfo.rawAmounts, trade = _derivedOrderInfo.trade, price = _derivedOrderInfo.price, inputError = _derivedOrderInfo.inputError, wrappedCurrencies = _derivedOrderInfo.wrappedCurrencies, singleTokenPrice = _derivedOrderInfo.singleTokenPrice, currencyIds = _derivedOrderInfo.currencyIds, _orderState = ref12.orderState, independentField = _orderState.independentField, basisField = _orderState.basisField, rateType = _orderState.rateType;
    var ref13 = (0,react.useState)({
        tradeToConfirm: undefined,
        attemptingTxn: false,
        swapErrorMessage: undefined,
        txHash: undefined
    }), ref14 = ref13[0], swapErrorMessage = ref14.swapErrorMessage, attemptingTxn = ref14.attemptingTxn, txHash = ref14.txHash, setSwapState = ref13[1];
    var ref15 = (0,_sliced_to_array/* default */.Z)((0,useApproveCallback/* useApproveCallbackFromInputCurrencyAmount */.tz)(parsedAmounts.input), 2), approvalState = ref15[0], approveCallback = ref15[1];
    var ref16 = (0,react.useState)(false), approvalSubmitted = ref16[0], setApprovalSubmitted = ref16[1];
    var maxAmountInput = (0,maxAmountSpend/* maxAmountSpend */.i)(currencyBalances.input);
    var hideMaxButton = Boolean(maxAmountInput && ((ref = parsedAmounts.input) === null || ref === void 0 ? void 0 : ref.equalTo(maxAmountInput)));
    // Trade execution price is always "in MUL mode", even if UI handles DIV rate
    var currentMarketRate = trade === null || trade === void 0 ? void 0 : trade.executionPrice;
    var percentageRateDifference = utils_getRatePercentageDifference(currentMarketRate, price);
    // UI handlers
    var handleTypeInput = (0,react.useCallback)(function(value) {
        handleInput(types/* Field.INPUT */.g.INPUT, value);
    }, [
        handleInput
    ]);
    var handleTypeOutput = (0,react.useCallback)(function(value) {
        handleInput(types/* Field.OUTPUT */.g.OUTPUT, value);
    }, [
        handleInput
    ]);
    var handleInputSelect = (0,react.useCallback)(function(inputCurrency) {
        setApprovalSubmitted(false);
        handleCurrencySelection(types/* Field.INPUT */.g.INPUT, inputCurrency);
    }, [
        handleCurrencySelection
    ]);
    var handleTypeDesiredRate = (0,react.useCallback)(function(value) {
        handleInput(types/* Field.PRICE */.g.PRICE, value);
    }, [
        handleInput
    ]);
    var handleMaxInput = (0,react.useCallback)(function() {
        if (maxAmountInput) {
            handleInput(types/* Field.INPUT */.g.INPUT, maxAmountInput.toExact());
        }
    }, [
        maxAmountInput,
        handleInput
    ]);
    var handleOutputSelect = (0,react.useCallback)(function(outputCurrency) {
        handleCurrencySelection(types/* Field.OUTPUT */.g.OUTPUT, outputCurrency);
    }, [
        handleCurrencySelection
    ]);
    var handleApprove = (0,react.useCallback)((0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return approveCallback();
                case 2:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })), [
        approveCallback
    ]);
    var handleConfirmDismiss = (0,react.useCallback)(function() {
        // if there was a tx hash, we want to clear the input
        if (txHash) {
            handleTypeInput("");
        }
    }, [
        txHash,
        handleTypeInput
    ]);
    // Trick to reset to market price via fake update on the basis field
    var handleResetToMarketPrice = (0,react.useCallback)(function() {
        if (basisField === types/* Field.INPUT */.g.INPUT) {
            handleTypeInput(formattedAmounts.input);
        } else {
            handleTypeOutput(formattedAmounts.output);
        }
    }, [
        handleTypeInput,
        handleTypeOutput,
        formattedAmounts.input,
        formattedAmounts.output,
        basisField
    ]);
    var handlePlaceOrder = (0,react.useCallback)(function() {
        if (!handleLimitOrderSubmission) {
            return;
        }
        setSwapState(function(prev) {
            return {
                attemptingTxn: true,
                tradeToConfirm: prev.tradeToConfirm,
                swapErrorMessage: undefined,
                txHash: undefined
            };
        });
        try {
            var ref, ref1, ref2, ref3;
            if (!((ref = wrappedCurrencies.input) === null || ref === void 0 ? void 0 : ref.address)) {
                throw new Error("Invalid input currency");
            }
            if (!((ref1 = wrappedCurrencies.output) === null || ref1 === void 0 ? void 0 : ref1.address)) {
                throw new Error("Invalid output currency");
            }
            if (!rawAmounts.input) {
                throw new Error("Invalid input amount");
            }
            if (!rawAmounts.output) {
                throw new Error("Invalid output amount");
            }
            if (!account) {
                throw new Error("No account");
            }
            var inputToken = (0,_instanceof/* default */.Z)(currencies.input, src/* Token */.WU) ? (ref2 = wrappedCurrencies.input) === null || ref2 === void 0 ? void 0 : ref2.address : constants/* GELATO_NATIVE */.ag;
            var outputToken = (0,_instanceof/* default */.Z)(currencies.output, src/* Token */.WU) ? (ref3 = wrappedCurrencies.output) === null || ref3 === void 0 ? void 0 : ref3.address : constants/* GELATO_NATIVE */.ag;
            var orderToSubmit = {
                inputToken: inputToken,
                outputToken: outputToken,
                inputAmount: rawAmounts.input,
                outputAmount: rawAmounts.output,
                owner: account
            };
            handleLimitOrderSubmission(orderToSubmit).then(function(param) {
                var hash = param.hash;
                setSwapState(function(prev) {
                    return {
                        attemptingTxn: false,
                        tradeToConfirm: prev.tradeToConfirm,
                        swapErrorMessage: undefined,
                        txHash: hash
                    };
                });
            }).catch(function(error) {
                setSwapState(function(prev) {
                    return {
                        attemptingTxn: false,
                        tradeToConfirm: prev.tradeToConfirm,
                        swapErrorMessage: error.message,
                        txHash: undefined
                    };
                });
            });
        } catch (error) {
            console.error(error);
        }
    }, [
        handleLimitOrderSubmission,
        account,
        rawAmounts.input,
        rawAmounts.output,
        currencies.input,
        currencies.output,
        (ref1 = wrappedCurrencies.input) === null || ref1 === void 0 ? void 0 : ref1.address,
        (ref2 = wrappedCurrencies.output) === null || ref2 === void 0 ? void 0 : ref2.address, 
    ]);
    var handleTokenSwitch = (0,react.useCallback)(function() {
        setApprovalSubmitted(false);
        handleSwitchTokens();
    }, [
        handleSwitchTokens
    ]);
    var realExecutionPriceAsString = useGasOverhead(parsedAmounts.input, parsedAmounts.output, rateType).realExecutionPriceAsString;
    var ref17 = (0,_sliced_to_array/* default */.Z)((0,useModal/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)(ConfirmLimitOrderModal, {
        currencies: currencies,
        formattedAmounts: formattedAmounts,
        currentMarketRate: currentMarketRate === null || currentMarketRate === void 0 ? void 0 : currentMarketRate.toSignificant(4),
        currentMarketRateInverted: currentMarketRate === null || currentMarketRate === void 0 ? void 0 : currentMarketRate.invert().toSignificant(4),
        limitPrice: price === null || price === void 0 ? void 0 : price.toSignificant(6),
        limitPriceInverted: price === null || price === void 0 ? void 0 : price.invert().toSignificant(6),
        percentageRateDifference: parseFloat(percentageRateDifference === null || percentageRateDifference === void 0 ? void 0 : percentageRateDifference.toSignificant(3)).toLocaleString(undefined, {
            minimumFractionDigits: 0,
            maximumFractionDigits: 3
        }),
        onConfirm: handlePlaceOrder,
        attemptingTxn: attemptingTxn,
        txHash: txHash,
        customOnDismiss: handleConfirmDismiss,
        swapErrorMessage: swapErrorMessage
    }), true, true, "confirmLimitOrderModal"), 1), showConfirmModal = ref17[0];
    // mark when a user has submitted an approval, reset onTokenSelection for input field
    (0,react.useEffect)(function() {
        if (approvalState === useApproveCallback/* ApprovalState.PENDING */.UK.PENDING) {
            setApprovalSubmitted(true);
        }
    }, [
        approvalState,
        approvalSubmitted
    ]);
    var showApproveFlow = !inputError && (approvalState === useApproveCallback/* ApprovalState.NOT_APPROVED */.UK.NOT_APPROVED || approvalState === useApproveCallback/* ApprovalState.PENDING */.UK.PENDING);
    var isSideFooter = isChartExpanded || isChartDisplayed;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Page/* default */.Z, {
        removePadding: isChartExpanded,
        hideFooterOnDesktop: isSideFooter,
        noMinHeight: true,
        helpUrl: exchange/* LIMIT_ORDERS_DOCS_URL */.vm,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ClaimWarning, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                width: "100%",
                justifyContent: "center",
                position: "relative",
                mb: isSideFooter ? null : "24px",
                mt: isChartExpanded ? "24px" : null,
                children: [
                    !isMobile && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        width: isChartExpanded ? "100%" : "50%",
                        maxWidth: "928px",
                        flexDirection: "column",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(PriceChartContainer/* default */.Z, {
                                inputCurrencyId: currencyIds.input,
                                inputCurrency: currencies.input,
                                outputCurrencyId: currencyIds.output,
                                outputCurrency: currencies.output,
                                isChartExpanded: isChartExpanded,
                                setIsChartExpanded: setIsChartExpanded,
                                isChartDisplayed: isChartDisplayed,
                                currentSwapPrice: singleTokenPrice,
                                isFullWidthContainer: true
                            }),
                            isChartDisplayed && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                mb: "48px"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                width: "100%",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_LimitOrderTable, {
                                    isCompact: isTablet
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        flexDirection: "column",
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSwapContainer, {
                                $isChartExpanded: false,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledInputCurrencyWrapper, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(App/* AppBody */.j, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_CurrencyInputHeader, {
                                                title: t("Limit"),
                                                subtitle: t("Place a limit order to trade at a set price"),
                                                setIsChartDisplayed: setIsChartDisplayed,
                                                isChartDisplayed: isChartDisplayed
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
                                                id: "limit-order-page",
                                                style: {
                                                    minHeight: "412px"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Column/* AutoColumn */.Tz, {
                                                        gap: "sm",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CurrencyInputPanel/* default */.Z, {
                                                                label: independentField === types/* Field.OUTPUT */.g.OUTPUT ? t("From (estimated)") : t("From"),
                                                                value: formattedAmounts.input,
                                                                showMaxButton: !hideMaxButton,
                                                                currency: currencies.input,
                                                                onUserInput: handleTypeInput,
                                                                onMax: handleMaxInput,
                                                                onCurrencySelect: handleInputSelect,
                                                                otherCurrency: currencies.output,
                                                                id: "limit-order-currency-input"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SwitchTokensButton, {
                                                                handleSwitchTokens: handleTokenSwitch,
                                                                color: currencies[types/* Field.INPUT */.g.INPUT] && currencies[types/* Field.OUTPUT */.g.OUTPUT] ? "primary" : "text"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CurrencyInputPanel/* default */.Z, {
                                                                value: formattedAmounts.output,
                                                                onUserInput: handleTypeOutput,
                                                                label: independentField === types/* Field.INPUT */.g.INPUT ? t("To (estimated)") : t("To"),
                                                                showMaxButton: false,
                                                                currency: currencies.output,
                                                                onCurrencySelect: handleOutputSelect,
                                                                otherCurrency: currencies.output,
                                                                id: "limit-order-currency-output"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_LimitOrderPrice, {
                                                                id: "limit-order-desired-rate-input",
                                                                value: formattedAmounts.price,
                                                                onUserInput: handleTypeDesiredRate,
                                                                inputCurrency: currencies.input,
                                                                outputCurrency: currencies.output,
                                                                percentageRateDifference: percentageRateDifference,
                                                                rateType: rateType,
                                                                handleRateType: handleRateType,
                                                                price: price,
                                                                handleResetToMarketPrice: handleResetToMarketPrice,
                                                                realExecutionPriceAsString: !inputError ? realExecutionPriceAsString : undefined,
                                                                disabled: !formattedAmounts.input && !formattedAmounts.output
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                        mt: "0.25rem",
                                                        children: !account ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ConnectWalletButton/* default */.Z, {
                                                            width: "100%"
                                                        }) : showApproveFlow ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                            variant: "primary",
                                                            onClick: handleApprove,
                                                            id: "enable-order-button",
                                                            width: "100%",
                                                            disabled: approvalSubmitted,
                                                            children: approvalSubmitted ? t("Enabling %asset%", {
                                                                asset: (ref3 = currencies.input) === null || ref3 === void 0 ? void 0 : ref3.symbol
                                                            }) : t("Enable %asset%", {
                                                                asset: (ref4 = currencies.input) === null || ref4 === void 0 ? void 0 : ref4.symbol
                                                            })
                                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                            variant: "primary",
                                                            onClick: function() {
                                                                setSwapState({
                                                                    tradeToConfirm: trade,
                                                                    attemptingTxn: false,
                                                                    swapErrorMessage: undefined,
                                                                    txHash: undefined
                                                                });
                                                                showConfirmModal();
                                                            },
                                                            id: "place-order-button",
                                                            width: "100%",
                                                            disabled: !!inputError || realExecutionPriceAsString === "never executes",
                                                            children: inputError || realExecutionPriceAsString === "never executes" ? inputError || t("Can't execute this order") : t("Place an Order")
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                                        mt: "16px",
                                                        justifyContent: "center",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                                            external: true,
                                                            href: "https://www.gelato.network/",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                src: theme.isDark ? "/images/powered_by_gelato_white.svg" : "/images/powered_by_gelato_black.svg",
                                                                alt: "Powered by Gelato",
                                                                width: "170px",
                                                                height: "48px"
                                                            })
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            }),
                            isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                mt: "24px",
                                width: "100%",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_LimitOrderTable, {
                                    isCompact: true
                                })
                            }),
                            isSideFooter && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                display: [
                                    "none",
                                    null,
                                    null,
                                    "block"
                                ],
                                width: "100%",
                                height: "100%",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer/* default */.Z, {
                                    variant: "side",
                                    helpUrl: exchange/* LIMIT_ORDERS_DOCS_URL */.vm
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BottomDrawer/* default */.Z, {
                content: /*#__PURE__*/ (0,jsx_runtime.jsx)(PriceChartContainer/* default */.Z, {
                    inputCurrencyId: currencyIds.input,
                    inputCurrency: currencies[types/* Field.INPUT */.g.INPUT],
                    outputCurrencyId: currencyIds.output,
                    outputCurrency: currencies[types/* Field.OUTPUT */.g.OUTPUT],
                    isChartExpanded: isChartExpanded,
                    setIsChartExpanded: setIsChartExpanded,
                    isChartDisplayed: isChartDisplayed,
                    currentSwapPrice: singleTokenPrice,
                    isMobile: true
                }),
                isOpen: isChartDisplayed,
                setIsOpen: setIsChartDisplayed
            })
        ]
    });
};
/* harmony default export */ var views_LimitOrders = (LimitOrders);

;// CONCATENATED MODULE: ./src/pages/limit-orders.tsx


var LimitOrdersPage = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(views_LimitOrders, {});
};
/* harmony default export */ var limit_orders = (LimitOrdersPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7425,4165,5855,3750,561,5652,3439,7882,2822,9774,2888,179], function() { return __webpack_exec__(84120); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);